import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import LiveChat from './LiveChat';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const motto = "Better Care, Less Work";
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);

  const togglePlay = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setDuration(videoRef.current.duration);
    }
  };

  const handleSeek = (e) => {
    e.stopPropagation();
    if (videoRef.current && duration > 0) {
      const rect = e.currentTarget.getBoundingClientRect();
      const pos = (e.clientX - rect.left) / rect.width;
      videoRef.current.currentTime = pos * duration;
    }
  };

  const [isActuallyPlaying, setIsActuallyPlaying] = useState(true);
  const [showMoreMenu, setShowMoreMenu] = useState(false);

  const handlePlay = () => setIsActuallyPlaying(true);
  const handlePause = () => setIsActuallyPlaying(false);

  const toggleMoreMenu = (e) => {
    e.stopPropagation();
    setShowMoreMenu(!showMoreMenu);
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    const link = document.createElement('a');
    link.href = '/cpvideo.mp4';
    link.download = 'ClinicPulse_Demo.mp4';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowMoreMenu(false);
  };

  const handlePiP = async (e) => {
    e.stopPropagation();
    try {
      if (videoRef.current !== document.pictureInPictureElement) {
        await videoRef.current.requestPictureInPicture();
      } else {
        await document.exitPictureInPicture();
      }
    } catch (error) {
      console.error('PiP failed', error);
    }
    setShowMoreMenu(false);
  };

  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const handleToggleSpeed = (e) => {
    e.stopPropagation();
    const speeds = [1, 1.5, 2, 0.5];
    const currentIndex = speeds.indexOf(playbackSpeed);
    const nextIndex = (currentIndex + 1) % speeds.length;
    const nextSpeed = speeds[nextIndex];
    if (videoRef.current) {
      videoRef.current.playbackRate = nextSpeed;
      setPlaybackSpeed(nextSpeed);
    }
    setShowMoreMenu(false);
  };

  const countryList = [
    { code: '+1', name: 'United States', maxLength: 10 },
    { code: '+91', name: 'India', maxLength: 10 },
    { code: '+44', name: 'United Kingdom', maxLength: 10 },
    { code: '+61', name: 'Australia', maxLength: 9 },
    { code: '+81', name: 'Japan', maxLength: 10 },
    { code: '+49', name: 'Germany', maxLength: 11 },
    { code: '+972', name: 'Israel', maxLength: 9 },
    { code: '+86', name: 'China', maxLength: 11 }
  ];

  const [selectedCountry, setSelectedCountry] = useState(countryList[1]);
  const [demoName, setDemoName] = useState('');
  const [demoCountry, setDemoCountry] = useState(countryList[1]);
  const [demoPhone, setDemoPhone] = useState('');
  const [demoEmail, setDemoEmail] = useState('');
  const [demoSubmitted, setDemoSubmitted] = useState(false);
  const [isSubmittingDemo, setIsSubmittingDemo] = useState(false);
  const [demoError, setDemoError] = useState('');
  const [trialForm, setTrialForm] = useState({
    name: '', email: '', phone: '', website: '', address: '', location: '', visitTime: '', about: '', logo: '', hasMedical: 'yes'
  });
  const [trialErrors, setTrialErrors] = useState({});
  const [trialTouched, setTrialTouched] = useState({});
  const [isSubmittingTrial, setIsSubmittingTrial] = useState(false);
  const [trialSuccess, setTrialSuccess] = useState(false);
  const [pendingClinicId, setPendingClinicId] = useState(null);
  const [verificationCode, setVerificationCode] = useState('');
  const [showRegistrationFields, setShowRegistrationFields] = useState(false);
  const [registerForm, setRegisterForm] = useState({ username: '', email: '', password: '', confirmPassword: '', firstName: '', lastName: '', role: '1' });
  const [registerErrors, setRegisterErrors] = useState({});
  const [passwordStrength, setPasswordStrength] = useState({ strength: 0, criteria: {} });
  const [verifyStep, setVerifyStep] = useState('initial');
  const [verificationMessage, setVerificationMessage] = useState('');
  const [serverError, setServerError] = useState('');
  const [authToken, setAuthToken] = useState('');
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [activeSlot, setActiveSlot] = useState('Morning');
  const [visitTimes, setVisitTimes] = useState({
    'Monday': [],
    'Tuesday': [],
    'Wednesday': [],
    'Thursday': [],
    'Friday': [],
    'Saturday': [],
    'Sunday': []
  });
  const [activeDay, setActiveDay] = useState('Monday');

  // Fixed API Base URL (use local proxy in development, render endpoint in production)
  const API_BASE_URL = process.env.NODE_ENV === 'development'
    ? '/api'
    : 'https://clinicpulseapi-1.onrender.com/api';

  const API_KEY = process.env.REACT_APP_API_KEY || '';
  const API_AUTH_TOKEN = process.env.REACT_APP_API_AUTH_TOKEN || '';

  const getApiHeaders = () => {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    const token = authToken || API_AUTH_TOKEN;
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }
    return headers;
  };

  const validateTrialForm = (data) => {
    let errors = {};
    if (!data.name.trim()) {
      errors.name = 'Name is required';
    } else if (/\d/.test(data.name)) {
      errors.name = 'Numbers not allowed';
    }

    if (!data.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^\d+$/.test(data.phone)) {
      errors.phone = 'Phone must contain digits only';
    } else if (data.phone.length > selectedCountry.maxLength) {
      errors.phone = `Maximum ${selectedCountry.maxLength} digits allowed for ${selectedCountry.name}`;
    } else if (data.phone.length < Math.max(6, selectedCountry.maxLength - 2)) {
      errors.phone = `Please enter at least ${Math.max(6, selectedCountry.maxLength - 2)} digits`;
    }

    if (!data.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
      errors.email = 'Invalid email address';
    }

    if (!data.address.trim()) {
      errors.address = 'Address is required';
    }

    if (!data.location.trim()) {
      errors.location = 'Location is required';
    }

    if (!data.visitTime.trim()) {
      errors.visitTime = 'Visit Time is required';
    }

    return errors;
  };

  // Fixed createClinic with correct endpoint
  const createClinic = async (data) => {
    try {
      setServerError('');
      setVerificationMessage('');

      const payload = {
        name: data.name,
        email: data.email,
        phone: `${selectedCountry.code}${data.phone}`,
        website: data.website || "",
        address: data.address || "",
        location: data.location || "",
        visitTime: data.visitTime || "",
        about: data.about || "",
        logo: data.logo || "",
        hasMedical: data.hasMedical === 'yes',
        hasPrescription: true
      };

      console.log('📡 Sending to:', `${API_BASE_URL}/Clinic/create`);
      console.log('📦 Payload:', payload);

      const response = await fetch(`${API_BASE_URL}/Clinic/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
      });

      console.log('📥 Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`HTTP ${response.status}: ${errorText.substring(0, 200)}`);
      }

      const contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) {
        const html = await response.text();
        throw new Error(`Expected JSON response but got HTML. ${html.substring(0, 200)}`);
      }

      const result = await response.json();
      console.log('✅ Success:', result);

      // capture auth token if API returns one (common with modern auth-enabled APIs)
      if (result?.token || result?.accessToken || result?.authToken) {
        setAuthToken(result.token || result.accessToken || result.authToken);
      }
      const clinicId = result?.clinicId || result?.id || result?.data?.clinicId;
      if (!clinicId) {
        throw new Error('Clinic creation failed: missing clinic ID');
      }

      setPendingClinicId(clinicId);
      setVerifyStep('pending');
      setVerificationMessage('Clinic created. Verification code sent to your email.');
      return clinicId;

    } catch (error) {
      console.error('❌ Create clinic error:', error);
      setServerError(error.message || 'Could not create clinic');
      throw error;
    }
  };

  // Fixed requestEmailVerification
  const requestEmailVerification = async (clinicId) => {
    try {
      setServerError('');
      setVerificationMessage('');

      console.log('📧 Sending verification to:', `${API_BASE_URL}/Clinic/VerifyNewEmail`);

      const response = await fetch(`${API_BASE_URL}/Clinic/VerifyNewEmail`, {
        method: 'POST',
        headers: getApiHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          clinicid: clinicId,
          email: trialForm.email
        }),
      });

      console.log('📥 Verification response:', response.status);

      if (response.status === 401 || response.status === 403) {
        let details = '';
        try {
          details = await response.text();
        } catch {
          details = response.statusText;
        }
        throw new Error(`Unauthorized (401/403): ${details || 'check API key/token or backend auth settings'}`);
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Verification request failed: ${text || response.statusText}`);
      }

      setVerificationMessage('Verification code sent to your email. Please check your inbox (including spam folder).');
      return true;
    } catch (error) {
      console.error('❌ Verification error:', error);
      setServerError(error.message || 'Could not send verification code');
      throw error;
    }
  };

  // Fixed confirmEmail
  const confirmEmail = async () => {
    if (!pendingClinicId) {
      setServerError('Clinic ID is missing');
      return;
    }
    if (!verificationCode.trim()) {
      setServerError('Please enter the verification code');
      return;
    }

    try {
      setServerError('');
      setVerificationMessage('');

      console.log('✅ Confirming email with code:', verificationCode);

      const response = await fetch(`${API_BASE_URL}/Clinic/ConfirmNewEmail`, {
        method: 'POST',
        headers: getApiHeaders(),
        credentials: 'include',
        body: JSON.stringify({
          code: verificationCode.trim(),
          clinicid: pendingClinicId
        }),
      });

      console.log('📥 Confirmation response:', response.status);

      if (response.status === 401 || response.status === 403) {
        let details = '';
        try {
          details = await response.text();
        } catch {
          details = response.statusText;
        }
        throw new Error(`Unauthorized (401/403): ${details || 'check API key/token or backend auth settings'}`);
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Confirmation failed: ${text || response.statusText}`);
      }

      setVerifyStep('verified');
      setTrialSuccess(true);
      setShowRegistrationFields(true); // Show registration fields now
      setVerificationMessage('✅ Email successfully verified! Now complete your registration.');
      // Keep pendingClinicId for the next step (registerUser)
      // setPendingClinicId(null); 
      setVerificationCode('');


      // Clear success message after 7 seconds
      setTimeout(() => setTrialSuccess(false), 7000);

      // Optional: Clear form
      // setTrialForm({
      //   name: '', email: '', phone: '', website: '', address: '', location: '', visitTime: '', about: '', logo: '', hasMedical: true, hasPrescription: true, isactive: true
      // });

      return true;
    } catch (error) {
      console.error('❌ Confirmation error:', error);
      setServerError(error.message || 'Email confirmation failed');
      throw error;
    }
  };

  const handleResendCode = async () => {
    if (!pendingClinicId) {
      setServerError('No pending clinic to verify');
      return;
    }
    setIsSubmittingTrial(true);
    try {
      await requestEmailVerification(pendingClinicId);
    } catch (error) {
      // serverError already set
    } finally {
      setIsSubmittingTrial(false);
    }
  };

  const handleConfirmCode = async () => {
    setIsSubmittingTrial(true);
    try {
      await confirmEmail();
    } catch (error) {
      // serverError already set
    } finally {
      setIsSubmittingTrial(false);
    }
  };

  const handleTrialChange = (e) => {
    const { name, value, type, checked } = e.target;
    let val = type === 'checkbox' ? checked : value;

    const attemptedNumberInName = name === 'name' && /\d/.test(value);
    const onlyDigits = name === 'phone' ? value.replace(/\D/g, '') : value;

    if (name === 'name' && attemptedNumberInName) {
      val = value.replace(/\d/g, '');
      setTrialTouched(prev => ({ ...prev, name: true }));
    } else if (name === 'phone') {
      let limited = onlyDigits;
      if (limited.length > selectedCountry.maxLength) {
        limited = limited.slice(0, selectedCountry.maxLength);
      }
      val = limited;
      setTrialTouched(prev => ({ ...prev, phone: true }));
    }

    const newData = { ...trialForm, [name]: val };
    setTrialForm(newData);

    if (trialTouched[name] || attemptedNumberInName || name === 'phone') {
      const newErrors = validateTrialForm(newData);
      if (attemptedNumberInName) {
        newErrors.name = 'Numbers not allowed';
      }
      setTrialErrors(newErrors);
    }
  };

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;

    // Username: only letters
    if (name === 'username') {
      const lettersOnly = value.replace(/[^a-zA-Z]/g, '');
      setRegisterForm((prev) => ({ ...prev, [name]: lettersOnly }));
      return;
    }

    // First Name: only letters
    if (name === 'firstName') {
      const lettersOnly = value.replace(/[^a-zA-Z]/g, '');
      setRegisterForm((prev) => ({ ...prev, [name]: lettersOnly }));
      return;
    }

    // Last Name: only letters
    if (name === 'lastName') {
      const lettersOnly = value.replace(/[^a-zA-Z]/g, '');
      setRegisterForm((prev) => ({ ...prev, [name]: lettersOnly }));
      return;
    }

    // Password: calculate strength
    if (name === 'password') {
      const criteria = {
        length: value.length >= 8,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        special: /[!@#$%^&*]/.test(value),
      };
      const strengthScore = Object.values(criteria).filter(Boolean).length;
      setPasswordStrength({ strength: strengthScore, criteria });
    }

    setRegisterForm((prev) => ({ ...prev, [name]: value }));
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength.strength <= 2) return '#EF4444'; // red
    if (passwordStrength.strength <= 4) return '#FBBF24'; // yellow
    return '#22C55E'; // green
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength.strength <= 2) return 'Weak';
    if (passwordStrength.strength <= 4) return 'Fair';
    return 'Strong';
  };

  const validateRegisterForm = (data) => {
    const errors = {};

    // Username validation
    if (!data.username.trim()) {
      errors.username = 'Username is required';
    } else if (!/^[a-zA-Z]+$/.test(data.username)) {
      errors.username = 'Username must contain only letters';
    }

    // Email validation
    if (!data.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
      errors.email = 'Invalid email format. Use: username@domain.com';
    }

    // Password validation
    if (!data.password.trim()) {
      errors.password = 'Password is required';
    } else if (data.password.length < 8) {
      errors.password = 'Password must be at least 8 characters';
    } else if (!/[A-Z]/.test(data.password)) {
      errors.password = 'Password must contain at least one uppercase letter';
    } else if (!/[a-z]/.test(data.password)) {
      errors.password = 'Password must contain at least one lowercase letter';
    } else if (!/[0-9]/.test(data.password)) {
      errors.password = 'Password must contain at least one number';
    } else if (!/[!@#$%^&*]/.test(data.password)) {
      errors.password = 'Password must contain at least one special character (!@#$%^&*)';
    }

    // Confirm password validation
    if (!data.confirmPassword.trim()) {
      errors.confirmPassword = 'Please confirm your password';
    } else if (data.password !== data.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    // First Name validation
    if (!data.firstName.trim()) {
      errors.firstName = 'First name is required';
    } else if (!/^[a-zA-Z]+$/.test(data.firstName)) {
      errors.firstName = 'First name must contain only letters';
    }

    // Last Name validation
    if (!data.lastName.trim()) {
      errors.lastName = 'Last name is required';
    } else if (!/^[a-zA-Z]+$/.test(data.lastName)) {
      errors.lastName = 'Last name must contain only letters';
    }

    return errors;
  };

  const handleTrialBlur = (e) => {
    const { name } = e.target;
    setTrialTouched(prev => ({ ...prev, [name]: true }));
    setTrialErrors(validateTrialForm(trialForm));
  };

  const registerUser = async (clinicId) => {
    const errors = validateRegisterForm(registerForm);
    setRegisterErrors(errors);
    if (Object.keys(errors).length > 0) {
      throw new Error('Please fix registration fields');
    }

    const payload = {
      username: registerForm.username,
      email: registerForm.email || trialForm.email,
      password: registerForm.password,
      firstName: registerForm.firstName,
      lastName: registerForm.lastName,
      clinicId: clinicId,
      role: Number(registerForm.role) || 1,
    };

    console.log('📤 User registration payload:', payload);

    const response = await fetch(`${API_BASE_URL}/Auth/register`, {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Register failed: ${text || response.statusText}`);
    }

    const result = await response.json();
    console.log('✅ User register response:', result);
    return result;
  };

  const handleVisitTimeClick = () => {
    setShowTimePicker(true);
  };

  const handleAddTime = (day, time) => {
    setVisitTimes(prev => {
      let activeDayTimes = [...prev[day]];


      if (activeDayTimes.includes(time)) {
        activeDayTimes = activeDayTimes.filter(t => t !== time);
      } else {
        if (activeDayTimes.length >= 6) {
          activeDayTimes = [time];
        } else {
          activeDayTimes.push(time);
        }
      }


      const newState = { ...prev, [day]: activeDayTimes };
      updateVisitTimeString(newState);
      return newState;
    });
  };

  const removeTime = (day, index) => {
    setVisitTimes(prev => {
      let activeDayTimes = [...prev[day]];
      activeDayTimes.splice(index, 1);
      const newState = { ...prev, [day]: activeDayTimes };
      updateVisitTimeString(newState);
      return newState;
    });
  };

  const clearDayTimings = (day) => {
    setVisitTimes(prev => {
      const newState = { ...prev, [day]: [] };
      updateVisitTimeString(newState);
      return newState;
    });
  };

  const clearAllVisitTimes = () => {
    setVisitTimes(prev => {
      const newState = {};
      Object.keys(prev).forEach(day => {
        newState[day] = [];
      });
      updateVisitTimeString(newState);
      return newState;
    });
  };

  const removeGroupTimings = (startDay, endDay) => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const startIndex = days.indexOf(startDay);
    const endIndex = days.indexOf(endDay);

    setVisitTimes(prev => {
      const newState = { ...prev };
      for (let i = startIndex; i <= endIndex; i++) {
        newState[days[i]] = [];
      }
      updateVisitTimeString(newState);
      return newState;
    });
  };

  const applyToAllDays = () => {
    const currentTimings = [...visitTimes[activeDay]];
    setVisitTimes(prev => {
      const newState = {};
      Object.keys(prev).forEach(day => {
        newState[day] = [...currentTimings];
      });
      updateVisitTimeString(newState);
      return newState;
    });
  };

  const getSessionFromTime = (timeStr) => {
    if (!timeStr) return "";
    const [time, period] = timeStr.split(' ');
    const hour = parseInt(time.split(':')[0]);


    if (period === 'AM') {
      if (hour >= 5 && hour < 12) return "Morning";
      return "Evening"; // Early morning handled as evening or morning depending on clinic
    } else {
      if (hour === 12 || hour < 5) return "Afternoon";
      return "Evening";
    }
  };

  const getGroupedSummary = (timesObj) => {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    let groups = [];
    let currentGroup = null;

    days.forEach((day, index) => {
      // Sort times correctly (AM/PM and Hour)
      const sortedTimes = [...timesObj[day]].sort((a, b) => {
        const timeToVal = (s) => {
          const [t, p] = s.split(' ');
          let [h, m] = t.split(':').map(Number);
          if (p === 'PM' && h !== 12) h += 12;
          if (p === 'AM' && h === 12) h = 0;
          return h * 60 + m;
        };
        return timeToVal(a) - timeToVal(b);
      });

      let sessionStrParts = [];
      for (let i = 0; i < sortedTimes.length; i += 2) {
        const start = sortedTimes[i];
        const end = sortedTimes[i + 1];
        const startSession = getSessionFromTime(start);
        const endSession = getSessionFromTime(end);

        if (!end) {
          sessionStrParts.push(`${startSession}: From ${start}`);
        } else if (startSession === endSession) {
          sessionStrParts.push(`${startSession}: From ${start} To ${end}`);
        } else {
          sessionStrParts.push(`${startSession}: From ${start} To ${endSession}: ${end}`);
        }
      }

      const sessionStr = sessionStrParts.join(' | ');

      if (!currentGroup || currentGroup.sessionStr !== sessionStr) {
        if (currentGroup) groups.push(currentGroup);
        currentGroup = { start: day, end: day, sessionStr: sessionStr };
      } else {
        currentGroup.end = day;
      }
      if (index === days.length - 1) groups.push(currentGroup);
    });

    return groups.filter(g => g.sessionStr);
  };

  const updateVisitTimeString = (timesObj) => {
    const groups = getGroupedSummary(timesObj);
    const formatted = groups.map(g => {
      const dayRange = g.start === g.end ? g.start : `${g.start}-${g.end}`;
      return `${dayRange}: ${g.sessionStr}`;
    }).join(' | ');
    setTrialForm(prev => ({ ...prev, visitTime: formatted }));
  };

  const [customHour, setCustomHour] = useState('09');
  const [customMinute, setCustomMinute] = useState('00');
  const [customPeriod, setCustomPeriod] = useState('AM');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  // Features Carousel State
  const [activeIndex, setActiveIndex] = useState(0);
  const features = [
    {
      title: "Patient Management",
      desc: "Comprehensive digital health records with quick access to medical history.",
      image: "/patient_mgmt.jpg",
      icon: "🏥",
      color: "#0366D6",
      tags: ["Digital Records", "Medical History", "Lab Results"]
    },
    {
      title: "Smart Scheduling",
      desc: "Reduce no-shows with automated reminders and an intuitive calendar.",
      image: "/smartscheduling.jpeg",
      icon: "📅",
      color: "#10B981",
      tags: ["Reminders", "Drag & Drop", "Calendar Sync"]
    },
    {
      title: "E-Prescriptions",
      desc: "Send prescriptions directly to pharmacies securely and safely.",
      image: "/eprescriptions.jpg",
      icon: "📝",
      color: "#0D9488",
      tags: ["Secure Transfer", "Safety Checks", "Instant Delivery"]
    },
    {
      title: "Automated Billing",
      desc: "Easy invoicing and insurance claim processing. Get paid faster.",
      image: "https://images.pexels.com/photos/5849559/pexels-photo-5849559.jpeg?auto=compress&cs=tinysrgb&w=400",
      icon: "💳",
      color: "#059669",
      tags: ["Fast Payouts", "Insurance Sync", "Auto-Invoicing"]
    },
    {
      title: "Advanced Analytics",
      desc: "Get insights into clinic performance and patient trends in real-time.",
      image: "https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=400",
      icon: "📊",
      color: "#3B82F6",
      tags: ["Heatmaps", "Finances", "Growth Tracking"]
    },
    {
      title: "Telemedicine",
      desc: "Provide virtual consultations securely with HD video calling.",
      image: "/telemedicine.jpg",
      icon: "📹",
      color: "#2563EB",
      tags: ["HD Video", "Encrypted", "Cloud Records"]
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % features.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);



  const [contactCountry, setContactCountry] = useState(countryList[1]); // Default to India
  const [contactPhone, setContactPhone] = useState('');
  const morningTimes = ['05:00 AM', '06:00 AM', '07:00 AM', '08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM'];
  const afternoonTimes = ['12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM'];
  const eveningTimes = ['06:00 PM', '07:00 PM', '08:00 PM', '09:00 PM', '10:00 PM', '11:00 PM', '12:00 AM'];


  const timeOptions = activeSlot === 'Morning' ? morningTimes : activeSlot === 'Afternoon' ? afternoonTimes : eveningTimes;

  const handleContinue = async () => {
    const errors = validateTrialForm(trialForm);
    setTrialErrors(errors);
    setTrialTouched(Object.keys(trialForm).reduce((acc, key) => ({ ...acc, [key]: true }), {}));
    setServerError('');

    if (Object.keys(errors).length > 0) {
      return;
    }

    setIsSubmittingTrial(true);
    try {
      const clinicId = await createClinic(trialForm);
      if (clinicId) {
        await requestEmailVerification(clinicId);
      }
    } catch (error) {
      // errors are handled in createClinic/requestEmailVerification
    } finally {
      setIsSubmittingTrial(false);
    }
  };

  const handleTrialSubmit = async (e) => {
    e.preventDefault();
    setServerError('');

    if (verifyStep !== 'verified') {
      setServerError('Please verify your email before registering a user.');
      return;
    }

    const regErrors = validateRegisterForm(registerForm);
    if (Object.keys(regErrors).length > 0) {
      setRegisterErrors(regErrors);
      setServerError('Please fix registration fields.');
      return;
    }

    setIsSubmittingTrial(true);
    try {
      if (pendingClinicId) {
        await registerUser(pendingClinicId);
        setVerificationMessage('✅ Registration complete! Welcome to ClinicPulse.');
        setPendingClinicId(null);
        setVerifyStep('initial');
        // Clear forms
        setTrialForm({
          name: '', email: '', phone: '', website: '', address: '', location: '', visitTime: '', about: '', logo: '', hasMedical: 'yes'
        });
        setRegisterForm({ username: '', email: '', password: '', confirmPassword: '', firstName: '', lastName: '', role: '1' });
        setShowRegistrationFields(false);


        // Redirect to admin login after 3 seconds
        setVerificationMessage('✅ Registration complete! Redirecting to your dashboard...');
        setTimeout(() => {
          window.location.href = 'https://clinicpulseadmin.netlify.app/login';
        }, 3000);
      } else {
        throw new Error('Clinic ID is missing. Please retry verification.');
      }
    } catch (error) {
      setServerError(error.message || 'Registration failed');
    } finally {
      setIsSubmittingTrial(false);
    }
  };

  const handleDemoSubmit = async (e) => {
    e.preventDefault();
    setDemoSubmitted(true);
    setDemoError('');

    if (demoEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(demoEmail)) return;
    if (!demoName || !demoPhone) return;

    setIsSubmittingDemo(true);
    try {
      const payload = {
        clinicName: demoName,
        phoneNumber: `${demoCountry.code}${demoPhone}`,
        email: demoEmail || ""
      };

      console.log('📡 Sending demo request to:', `${API_BASE_URL}/DemoRequest/request`);
      console.log('📦 Payload:', payload);

      const response = await fetch(`${API_BASE_URL}/DemoRequest/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
      });

      console.log('📥 Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(errorText || `HTTP ${response.status}`);
      }

      alert('Thank you! Your demo request has been received.');
      setShowDemoModal(false);
      setDemoSubmitted(false);
      setDemoName('');
      setDemoPhone('');
      setDemoEmail('');
    } catch (error) {
      console.error('❌ Demo request error:', error);
      setDemoError(error.message || 'Could not send demo request. Please try again.');
    } finally {
      setIsSubmittingDemo(false);
    }
  };

  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      // Hide mobile menu when scrolling
      setMobileMenuOpen(false);
      // Add visual feedback of scrolling state
      document.documentElement.setAttribute('data-scrolling', 'true');
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        document.documentElement.removeAttribute('data-scrolling');
      }, 1000);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  useEffect(() => {
    if (showVideo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showVideo]);

  // NOTE: API connection test removed to avoid browser CORS preflight failures during local development.
  // Use server-side CORS or proxy via package.json to resolve.
  // useEffect(() => {
  //   const testAPIConnection = async () => {
  //     try {
  //       console.log('🔍 Testing API connection...');
  //       const response = await fetch(`${API_BASE_URL}/Clinic/get`);
  //       console.log('API Connection test:', response.status === 200 ? '✅ OK' : `⚠️ Status: ${response.status}`);
  //     } catch (error) {
  //       console.error('❌ API Connection failed:', error.message);
  //     }
  //   };
  //   testAPIConnection();
  // }, []);

  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const testimonials = [
    {
      name: "Dr. Sankar",
      role: "Theni, Tamil Nadu",
      text: "I must say I love ClinicPulse. It is a fantastic clinic software and I'm so glad to have switched over to it. The patient portal is exceptional!",
      image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&w=150&q=80"
    },
    {
      name: "Dr. Nirmal",
      role: "Chennai, Tamil Nadu",
      text: "ClinicPulse transformed our patient management workflow. The e-prescription feature alone has saved us hours every week. Amazing product!",
      image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&w=150&q=80"
    },
    {
      name: "Dr. Sathyaprakash",
      role: "Madurai, Tamil Nadu",
      text: "Our patients absolutely love ClinicPulse! The automated appointment reminders have reduced our no-show rate by 45%. It's a game changer!",
      image: "https://images.unsplash.com/photo-1594824436998-d8bd247bdba7?auto=format&fit=crop&w=150&q=80"
    },
    {
      name: "Dr. Aarthi",
      role: "Erode, Tamil Nadu",
      text: "ClinicPulse completely revolutionized our clinic operations. We reduced administrative errors by 95% and improved patient satisfaction significantly.",
      image: "https://images.unsplash.com/photo-1537368910025-7028a4ce10f6?auto=format&fit=crop&w=150&q=80"
    }
  ];

  const nextTestimonial = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  return (
    <>
      <LiveChat />
      <div className="App">
        {/* Navbar */}
        <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${mobileMenuOpen ? 'mobile-nav-open' : ''}`}>
          <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div className="nav-logo" onClick={() => window.scrollTo(0, 0)}>
              <img src="/logo_full.png" alt="ClinicPulse Logo" className="navbar-logo-img" />
            </div>

            <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <div className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>

            <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
              <div className="mobile-nav-brand">
                <img src="/logo_full.png" alt="ClinicPulse Logo" style={{ height: '65px', width: 'auto' }} />
              </div>
              <a href="#features" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Features</a>
              <a href="#how-it-works" className="nav-link" onClick={() => setMobileMenuOpen(false)}>How it Works</a>
              <a href="#testimonials" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Testimonials</a>
              <a href="#contact" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Contact</a>
              <a href="#trial" className="nav-link" style={{ marginLeft: '1rem' }} onClick={() => setMobileMenuOpen(false)}>Register</a>
              <a href="https://clinicpulseadmin.netlify.app/login" target="_blank" rel="noopener noreferrer" className="btn btn-dashboard" onClick={() => setMobileMenuOpen(false)}>Go to Dashboard</a>
            </div>
          </div>
        </nav>

        {/* Mobile Menu Overlay */}
        <div
          className={`nav-overlay ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(false)}
        ></div>

        {/* Hero Section */}
        <header className="hero">
          <div className="container hero-grid">
            <div className="hero-content animate-fade-in-up">
              <h1>Smart Clinic Management – <span className="gradient-text">Better Care, Less Work.</span></h1>
              <p>
                Automate appointments, digitize records, and boost efficiency with ClinicPulse.
              </p>
              <div className="hero-btns">
                <a href="#trial" className="btn btn-primary" style={{ textDecoration: 'none' }}>Start Free Trial</a>
                <button className="btn btn-secondary" onClick={() => setShowVideo(true)}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                  See How It Works
                </button>
              </div>
            </div>

            <div className="hero-image-container animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              <img src="/dashboardimage.jpeg" alt="Clinic Dashboard" className="hero-image" onError={(e) => e.target.src = 'https://placehold.co/1000x600/3B82F6/ffffff?text=Clinic+Dashboard+Mockup'} />

              <div className="floating-card glass animate-float" style={{ top: '10%', right: '-5%', animationDelay: '0s' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div className="pulse-primary" style={{ width: 12, height: 12, borderRadius: '50%', background: 'var(--secondary)' }}></div>
                  <span style={{ fontSize: '0.85rem', fontWeight: 700, color: 'var(--text-main)' }}>Live Clinic Status</span>
                </div>
              </div>

              <div className="floating-card glass animate-float pulse-primary" style={{ bottom: '20%', left: '-5%', animationDelay: '1s', background: 'var(--text-main)', border: 'none' }}>
                <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#fff' }}>✓ HIPAA Verified</span>
              </div>
            </div>
          </div>
        </header>

        {/* Features Section - Split Layout with Stacked Carousel */}
        {/* Features Section - Split Layout with Stacked Carousel */}
        <section id="features" style={{ background: '#F8FAFC', padding: '6rem 0', overflow: 'hidden' }}>
          <div className="container">
            <div className="section-header" style={{ marginBottom: '4rem' }}>
              <h2>Powerful Features for <span className="gradient-text">Modern Clinics</span></h2>
              <p>Everything you need to manage your medical practice efficiently and effectively.</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '2.5rem', alignItems: 'center' }}>
              {/* Left Side - Features Carousel */}
              <div className="feature-stack-wrapper-left">
                <div className="feature-stack-container" style={{ margin: 0, height: '400px' }}>
                  {features.map((feature, index) => {
                    let position = index - activeIndex;
                    const total = features.length;

                    if (position <= -total / 2) position += total;
                    if (position > total / 2) position -= total;

                    let opacity = 0;
                    let scale = 0.4;
                    let xTranslate = 0;
                    let zIndex = 0;
                    let filter = 'blur(2px)';

                    if (position === 0) {
                      opacity = 1; scale = 1; xTranslate = 0; zIndex = 10; filter = 'blur(0px)';
                    } else if (Math.abs(position) === 1) {
                      opacity = 0.5; scale = 0.8; xTranslate = position * 35; zIndex = 5;
                    } else if (Math.abs(position) === 2) {
                      opacity = 0.2; scale = 0.65; xTranslate = position * 60; zIndex = 2;
                    } else if (Math.abs(position) === 3 || Math.abs(position) === total / 2) {
                      opacity = 0.05; scale = 0.5; xTranslate = position * 80; zIndex = 1;
                    }

                    return (
                      <div
                        key={index}
                        className={`feature-stack-card ${position === 0 ? 'active' : ''}`}
                        style={{
                          '--card-color': feature.color,
                          opacity,
                          zIndex,
                          transform: `translateX(calc(-50% + ${xTranslate}%)) scale(${scale})`,
                          left: '50%',
                          top: '50%',
                          marginTop: '-180px', // Half of height
                          width: '240px',
                          height: '360px',
                          filter
                        }}
                        onClick={() => setActiveIndex(index)}
                      >
                        <div className="card-top-inner" style={{ height: '40%', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <img
                            src={feature.image}
                            alt={feature.title}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextElementSibling.style.display = 'block';
                            }}
                          />
                          <span style={{ fontSize: '3rem', display: 'none' }}>{feature.icon}</span>
                        </div>
                        <div className="card-bottom-inner" style={{ padding: '1.5rem 1rem' }}>
                          <h3 style={{ fontSize: '1rem' }}>{feature.title}</h3>
                          <p style={{ fontSize: '0.8rem', marginBottom: '1rem' }}>{feature.desc}</p>
                          <div className="feature-card-tags" style={{ marginBottom: '1rem', gap: '0.3rem' }}>
                            {feature.tags.map(tag => (
                              <span key={tag} style={{ fontSize: '0.65rem', padding: '0.2rem 0.5rem' }}>{tag}</span>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="feature-stack-dots" style={{ marginTop: '2rem' }}>
                  {features.map((_, i) => (
                    <div
                      key={i}
                      className={`stack-dot ${i === activeIndex ? 'active' : ''}`}
                      onClick={() => setActiveIndex(i)}
                    ></div>
                  ))}

                </div>
              </div>

              {/* Right Side - Doctor Image (Resized to match cards) with Floating Icons */}
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', minWidth: '320px' }}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1, width: '130%', height: '130%' }}>
                  <svg viewBox="0 0 400 480" fill="none" style={{ width: '100%', height: '100%' }}>
                    <path d="M200 40C280 40 340 100 340 180C340 220 360 260 360 300C360 380 300 440 200 440C100 440 40 380 40 300C40 260 60 220 60 180C60 100 120 40 200 40Z" fill="#0366D6" opacity="0.08" />
                  </svg>
                </div>
                <div style={{ position: 'relative', zIndex: 2 }}>
                  <img
                    src="/doctorimg.jpeg"
                    alt="Doctor"
                    style={{
                      width: '240px',
                      height: '360px',
                      objectFit: 'cover',
                      borderRadius: '24px',
                      boxShadow: '0 30px 60px rgba(15, 23, 42, 0.15)',
                      display: 'block',
                      border: '6px solid white'
                    }}
                  />

                  {/* Floating Stat Bubble */}
                  <div className="glass pulse-primary" style={{ position: 'absolute', bottom: '5%', left: '-25%', padding: '0.75rem 1rem', borderRadius: '12px', zIndex: 3, minWidth: '120px' }}>
                    <div style={{ fontWeight: 800, fontSize: '1rem', color: '#0366D6' }}>2.4k+</div>
                    <div style={{ fontSize: '0.6rem', opacity: 0.7 }}>Active Patients</div>
                  </div>

                  {/* 6 Floating Feature Icons with Tooltips */}
                  <div className="floating-bubble" style={{ position: 'absolute', top: '10%', left: '-15%', animationDelay: '0s', cursor: 'pointer', border: activeIndex === 0 ? '2px solid #3B82F6' : '' }} onClick={() => setActiveIndex(0)}>
                    <span style={{ fontSize: '1.2rem' }}>🏥</span>
                    <div className="bubble-tooltip" style={{ opacity: activeIndex === 0 ? 1 : '', visibility: activeIndex === 0 ? 'visible' : '' }}>Patient Management</div>
                  </div>
                  <div className="floating-bubble" style={{ position: 'absolute', top: '-10%', right: '5%', animationDelay: '0.5s', cursor: 'pointer', border: activeIndex === 1 ? '2px solid #3B82F6' : '' }} onClick={() => setActiveIndex(1)}>
                    <span style={{ fontSize: '1.2rem' }}>📅</span>
                    <div className="bubble-tooltip" style={{ opacity: activeIndex === 1 ? 1 : '', visibility: activeIndex === 1 ? 'visible' : '' }}>Smart Scheduling</div>
                  </div>
                  <div className="floating-bubble" style={{ position: 'absolute', top: '40%', right: '-20%', animationDelay: '1s', cursor: 'pointer', border: activeIndex === 2 ? '2px solid #3B82F6' : '' }} onClick={() => setActiveIndex(2)}>
                    <span style={{ fontSize: '1.2rem' }}>📝</span>
                    <div className="bubble-tooltip" style={{ opacity: activeIndex === 2 ? 1 : '', visibility: activeIndex === 2 ? 'visible' : '' }}>E-Prescriptions</div>
                  </div>
                  <div className="floating-bubble" style={{ position: 'absolute', bottom: '20%', right: '-15%', animationDelay: '1.5s', cursor: 'pointer', border: activeIndex === 3 ? '2px solid #3B82F6' : '' }} onClick={() => setActiveIndex(3)}>
                    <span style={{ fontSize: '1.2rem' }}>💳</span>
                    <div className="bubble-tooltip" style={{ opacity: activeIndex === 3 ? 1 : '', visibility: activeIndex === 3 ? 'visible' : '' }}>Automated Billing</div>
                  </div>
                  <div className="floating-bubble" style={{ position: 'absolute', bottom: '-5%', left: '10%', animationDelay: '2s', cursor: 'pointer', border: activeIndex === 4 ? '2px solid #3B82F6' : '' }} onClick={() => setActiveIndex(4)}>
                    <span style={{ fontSize: '1.2rem' }}>📊</span>
                    <div className="bubble-tooltip" style={{ opacity: activeIndex === 4 ? 1 : '', visibility: activeIndex === 4 ? 'visible' : '' }}>Advanced Analytics</div>
                  </div>
                  <div className="floating-bubble" style={{ position: 'absolute', top: '35%', left: '-25%', animationDelay: '2.5s', cursor: 'pointer', border: activeIndex === 5 ? '2px solid #3B82F6' : '' }} onClick={() => setActiveIndex(5)}>
                    <span style={{ fontSize: '1.2rem' }}>📹</span>
                    <div className="bubble-tooltip" style={{ opacity: activeIndex === 5 ? 1 : '', visibility: activeIndex === 5 ? 'visible' : '' }}>Telemedicine</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How it Works */}
        <section id="how-it-works" style={{ background: 'white', padding: '4rem 0' }}>
          <div className="container">
            <div className="section-header">
              <h2>Set up your clinic in <span className="gradient-text">3 steps</span>.</h2>
              <p>Get your clinic up and running in no time</p>
            </div>

            {/* Horizontal Steps with Icons and Arrows */}
            <div className="how-steps-grid">
              {/* Step 1 */}
              <div className="how-step">
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #E0F2FE 0%, #D1E7F5 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                  boxShadow: '0 12px 32px rgba(3, 102, 214, 0.2)'
                }}>
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#0366D6" strokeWidth="1.5">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                    <path d="M2 17l10 5 10-5"></path>
                    <path d="M2 12l10 5 10-5"></path>
                  </svg>
                </div>
                <div style={{ textAlign: 'center', maxWidth: '200px' }}>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--text-main)' }}>
                    Create a Clinic Profile
                  </h3>
                  <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>
                    Register your profile and set up your clinic details
                  </p>
                </div>
              </div>

              {/* Arrow 1 */}
              <div className="step-arrow">
                <svg viewBox="0 0 120 24" fill="none" stroke="#bbb" strokeWidth="2" strokeDasharray="5,5">
                  <line x1="5" y1="12" x2="105" y2="12"></line>
                  <polyline points="100 5 110 12 100 19"></polyline>
                </svg>
              </div>

              {/* Step 2 */}
              <div className="how-step">
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #D1FAE5 0%, #C1F5DC 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                  boxShadow: '0 12px 32px rgba(16, 185, 129, 0.2)'
                }}>
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="1.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div style={{ textAlign: 'center', maxWidth: '200px' }}>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--text-main)' }}>
                    Add users and their roles
                  </h3>
                  <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>
                    Define roles for efficient task management
                  </p>
                </div>
              </div>

              {/* Arrow 2 */}
              <div className="step-arrow">
                <svg viewBox="0 0 120 24" fill="none" stroke="#bbb" strokeWidth="2" strokeDasharray="5,5">
                  <line x1="5" y1="12" x2="105" y2="12"></line>
                  <polyline points="100 5 110 12 100 19"></polyline>
                </svg>
              </div>

              {/* Step 3 */}
              <div className="how-step">
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #E0F2FE 0%, #D1E7F5 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                  boxShadow: '0 12px 32px rgba(3, 102, 214, 0.2)'
                }}>
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#0366D6" strokeWidth="1.5">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
                <div style={{ textAlign: 'center', maxWidth: '200px' }}>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--text-main)' }}>
                    Schedule and manage bookings
                  </h3>
                  <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>
                    Add appointments based on doctor availability
                  </p>
                </div>
              </div>
            </div>

            {/* Video Section Below Steps */}
            <div style={{ marginTop: '4rem' }}>
              <div className="mockup-container">
                <div className="mockup-inner">
                  <div className="video-embed-container" onClick={() => setShowVideo(true)}>
                    <video
                      ref={videoRef}
                      className="embedded-video"
                      autoPlay
                      loop
                      muted={isMuted}
                      playsInline
                      src="/cpvideo.mp4"
                      poster="/dashboardimage.jpeg"
                      onTimeUpdate={handleTimeUpdate}
                      onLoadedMetadata={handleLoadedMetadata}
                      onPlay={handlePlay}
                      onPause={handlePause}
                    >
                      Your browser does not support the video tag.
                    </video>
                    <div className="video-overlay-gradient"></div>
                    <div className="video-player-controls">
                      <div className="v-control-left" onClick={togglePlay}>
                        {isActuallyPlaying ? (
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                            <rect x="6" y="4" width="4" height="16" />
                            <rect x="14" y="4" width="4" height="16" />
                          </svg>
                        ) : (
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        )}
                        <span className="v-time">{formatTime(currentTime)} / {formatTime(duration)}</span>
                      </div>
                      <div className="v-progress-container" onClick={handleSeek}>
                        <div className="v-progress-bar">
                          <div className="v-progress-fill" style={{ width: `${(currentTime / duration) * 100}%` }}>
                            <div className="v-progress-thumb"></div>
                          </div>
                        </div>
                      </div>
                      <div className="v-control-right">
                        <div onClick={toggleMute} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                          {isMuted ? (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                              <path d="M11 5L6 9H2v6h4l5 4V5z"></path>
                              <line x1="23" y1="9" x2="17" y2="15"></line>
                              <line x1="17" y1="9" x2="23" y2="15"></line>
                            </svg>
                          ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                              <path d="M11 5L6 9H2v6h4l5 4V5z"></path>
                              <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                            </svg>
                          )}
                        </div>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>
                        <div className="v-more-container">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="2"
                            onClick={toggleMoreMenu}
                            style={{ cursor: 'pointer' }}
                          >
                            <circle cx="12" cy="5" r="1.5"></circle>
                            <circle cx="12" cy="12" r="1.5"></circle>
                            <circle cx="12" cy="19" r="1.5"></circle>
                          </svg>

                          {showMoreMenu && (
                            <div className="v-more-menu" onClick={(e) => e.stopPropagation()}>
                              <div className="v-menu-item" onClick={handleDownload}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 17v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3"></path><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="2" x2="12" y2="16"></line></svg>
                                <span>Download</span>
                              </div>
                              <div className="v-menu-item" onClick={handleToggleSpeed}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>
                                <span>Playback speed ({playbackSpeed}x)</span>
                              </div>
                              <div className="v-menu-item" onClick={handlePiP}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 19h7V7H4v7"></path><rect x="4" y="14" width="9" height="5"></rect></svg>
                                <span>Picture in picture</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section id="testimonials" style={{ background: 'white', color: 'var(--text-main)', padding: '5rem 0' }}>
          <div className="container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="section-header" style={{ marginBottom: '3rem' }}>
              <h2>What <span className="gradient-text">Doctors Say</span></h2>
              <p style={{ color: 'var(--text-muted)' }}>Trusted by over 10,000 healthcare professionals worldwide.</p>
            </div>

            <div className="testimonial-slider-wrapper">
              <button className="slider-nav-btn prev" onClick={prevTestimonial}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
              </button>

              <div className="testimonial-slide-card">
                <div className="testimonial-quote-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                </div>
                <h3 className="testimonial-text">"{testimonials[activeTestimonial].text}"</h3>
                <div className="testimonial-author-block">
                  <div style={{ position: 'relative', width: '60px', height: '60px', flexShrink: 0 }}>
                    <div
                      style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'linear-gradient(135deg, #D1FAE5 0%, #A7F3D0 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px', fontWeight: 700, color: '#0366D6', boxShadow: '0 4px 12px rgba(16, 185, 129, 0.2)', border: '2px solid white' }}
                    >
                      {testimonials[activeTestimonial].name.replace(/^Dr\.\s*/, '').charAt(0).toUpperCase()}
                    </div>
                  </div>
                  <div className="author-info">
                    <h4>Dr. {testimonials[activeTestimonial].name.replace(/^Dr\.\s*/, '')}</h4>
                    <p>{testimonials[activeTestimonial].role}</p>
                  </div>
                </div>
              </div>

              <button className="slider-nav-btn next" onClick={nextTestimonial}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
              </button>
            </div>

            <div className="slider-dots">
              {testimonials.map((_, idx) => (
                <div
                  key={idx}
                  className={`slider-dot ${idx === activeTestimonial ? 'active' : ''}`}
                  onClick={() => setActiveTestimonial(idx)}
                ></div>
              ))}
            </div>

            <div className="stats-grid" style={{ marginTop: '5rem', width: '100%' }}>
              <div className="stat-item" style={{ color: 'var(--text-main)', background: '#F8FAFC', padding: '2rem', borderRadius: '16px' }}>
                <h3 style={{ color: 'var(--primary)' }}>10,000+</h3>
                <p style={{ color: 'var(--text-muted)' }}>Clinics Trust Us</p>
              </div>
              <div className="stat-item" style={{ color: 'var(--text-main)', background: '#F8FAFC', padding: '2rem', borderRadius: '16px' }}>
                <h3 style={{ color: 'var(--primary)' }}>99.9%</h3>
                <p style={{ color: 'var(--text-muted)' }}>Uptime Guarantee</p>
              </div>
              <div className="stat-item" style={{ color: 'var(--text-main)', background: '#F8FAFC', padding: '2rem', borderRadius: '16px' }}>
                <h3 style={{ color: 'var(--primary)' }}>4.9/5</h3>
                <p style={{ color: 'var(--text-muted)' }}>Customer Rating</p>
              </div>
              <div className="stat-item" style={{ color: 'var(--text-main)', background: '#F8FAFC', padding: '2rem', borderRadius: '16px' }}>
                <h3 style={{ color: 'var(--primary)' }}>24/7</h3>
                <p style={{ color: 'var(--text-muted)' }}>Support Available</p>
              </div>
            </div>
          </div>
        </section>

        {/* Combined CTA & Trial Section */}
        <section className="cta-section" id="trial">
          <div className="container">
            <div className="cta-split-layout">
              <div className="cta-content-left">
                <span className="cta-tag">🚀 Start Your Free Trial Today</span>
                <h2>Ready to Transform Your <br /><span style={{ opacity: 0.8 }}>Clinic Management?</span></h2>
                <p>
                  Join thousands of clinics already using ClinicPulse to streamline patient records,
                  boost productivity, and reduce administrative overhead.
                </p>

                <div className="hero-btns" style={{ marginTop: '2.5rem' }}>
                  <a href="#trial" className="btn" style={{ background: 'white', color: 'var(--primary)', textDecoration: 'none' }}>
                    Start Free Trial <span style={{ fontSize: '0.75rem', background: 'var(--secondary)', color: 'white', padding: '2px 8px', borderRadius: '10px', marginLeft: '5px' }}>30 Days</span>
                  </a>
                  <button className="btn" style={{ border: '1px solid rgba(255,255,255,0.4)', color: 'white' }} onClick={() => setShowDemoModal(true)}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    Schedule Demo
                  </button>
                </div>
              </div>

              <div className="cta-form-right">
                <div className="trial-form-card glass">
                  <div className="form-header" style={{ marginBottom: '1.5rem' }}>
                    <div>
                      <h3>Get Your <span className="gradient-text">Free Trial</span></h3>
                      <p style={{ marginTop: '0.25rem' }}>Start managing your clinic more efficiently today.</p>
                    </div>
                  </div>
                  <form className="trial-form-grid" onSubmit={handleTrialSubmit}>

                    <div className="input-group">
                      <label>🏢 Clinic Name *</label>
                      <input type="text" name="name" placeholder="Your clinic name" value={trialForm.name} onChange={handleTrialChange} onBlur={handleTrialBlur} style={{ borderColor: trialErrors.name && trialTouched.name ? '#EF4444' : '#E2E8F0', background: trialErrors.name && trialTouched.name ? '#fef2f2' : '#F8FAFC' }} />
                      {trialErrors.name && trialTouched.name && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>{trialErrors.name}</span>}
                    </div>
                    <div className="input-group">
                      <label>📧 Email *</label>
                      <input type="email" name="email" placeholder="email@example.com" value={trialForm.email} onChange={handleTrialChange} onBlur={handleTrialBlur} style={{ borderColor: trialErrors.email && trialTouched.email ? '#EF4444' : '#E2E8F0', background: trialErrors.email && trialTouched.email ? '#fef2f2' : '#F8FAFC' }} />
                      {trialErrors.email && trialTouched.email && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>{trialErrors.email}</span>}
                    </div>
                    <div className="input-group">
                      <label>📱 Phone *</label>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <select
                          className="mobile-country-select"
                          value={selectedCountry.code}
                          onChange={(e) => {
                            const country = countryList.find(c => c.code === e.target.value);
                            setSelectedCountry(country || countryList[1]);
                            if (trialForm.phone.length > (country?.maxLength || countryList[1].maxLength)) {
                              setTrialForm(prev => ({ ...prev, phone: prev.phone.slice(0, country.maxLength) }));
                            }
                          }}
                          style={{ width: '40%', padding: '0.6rem 0.5rem', borderRadius: '8px', border: '1px solid #E2E8F0', background: '#F8FAFC', fontSize: '0.8rem' }}
                        >
                          {countryList.map(country => (
                            <option key={country.code} value={country.code}>
                              {country.code} {country.name}
                            </option>
                          ))}
                        </select>
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone number"
                          value={trialForm.phone}
                          onChange={handleTrialChange}
                          onBlur={handleTrialBlur}
                          maxLength={selectedCountry.maxLength}
                          style={{
                            flex: '1',
                            borderColor: trialErrors.phone && trialTouched.phone ? '#EF4444' : '#E2E8F0',
                            background: trialErrors.phone && trialTouched.phone ? '#fef2f2' : '#F8FAFC',
                            padding: '0.6rem 0.75rem',
                            borderRadius: '8px'
                          }}
                        />
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2px' }}>
                        <span style={{ fontSize: '0.75rem', color: '#64748B' }}>
                          {trialForm.phone.length}/{selectedCountry.maxLength} digits
                        </span>
                        {trialErrors.phone && trialTouched.phone && (
                          <span style={{ color: '#EF4444', fontSize: '0.75rem' }}>{trialErrors.phone}</span>
                        )}
                      </div>
                    </div>
                    <div className="input-group">
                      <label>🌐 Website</label>
                      <input type="url" name="website" placeholder="https://..." value={trialForm.website} onChange={handleTrialChange} />
                    </div>
                    <div className="input-group" style={{ gridColumn: 'span 2' }}>
                      <label>📍 Address *</label>
                      <input
                        type="text"
                        name="address"
                        placeholder="Full address"
                        value={trialForm.address}
                        onChange={handleTrialChange}
                        onBlur={handleTrialBlur}
                        style={{
                          borderColor: trialErrors.address && trialTouched.address ? '#EF4444' : '#E2E8F0',
                          background: trialErrors.address && trialTouched.address ? '#fef2f2' : '#F8FAFC'
                        }}
                      />
                      {trialErrors.address && trialTouched.address && (
                        <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>{trialErrors.address}</span>
                      )}
                    </div>
                    <div className="input-group">
                      <label>🏢 Location *</label>
                      <input
                        type="text"
                        name="location"
                        placeholder="City / Area"
                        value={trialForm.location}
                        onChange={handleTrialChange}
                        onBlur={handleTrialBlur}
                        style={{
                          borderColor: trialErrors.location && trialTouched.location ? '#EF4444' : '#E2E8F0',
                          background: trialErrors.location && trialTouched.location ? '#fef2f2' : '#F8FAFC'
                        }}
                      />
                      {trialErrors.location && trialTouched.location && (
                        <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>{trialErrors.location}</span>
                      )}
                    </div>
                    <div className="input-group">
                      <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#6366f1' }}>
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                          Visit Time *
                        </div>
                        {trialForm.visitTime !== 'Open 24 Hours' && (
                          <button
                            type="button"
                            onClick={handleVisitTimeClick}
                            style={{ background: 'transparent', border: 'none', color: '#6366f1', display: 'flex', alignItems: 'center', gap: '0.2rem', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 700 }}
                          >
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                            Edit Options
                          </button>
                        )}
                      </label>
                      <div
                        name="visitTime"
                        onClick={() => {
                          if (trialForm.visitTime !== 'Open 24 Hours') handleVisitTimeClick();
                        }}
                        style={{
                          cursor: trialForm.visitTime === 'Open 24 Hours' ? 'not-allowed' : 'pointer',
                          minHeight: '44px',
                          padding: '0.6rem 0.75rem',
                          borderRadius: '8px',
                          border: trialErrors.visitTime && trialTouched.visitTime ? '1px solid #EF4444' : '1px solid #E2E8F0',
                          background: trialErrors.visitTime && trialTouched.visitTime ? '#fef2f2' : (trialForm.visitTime === 'Open 24 Hours' ? '#f1f5f9' : '#F8FAFC'),
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '0.4rem',
                          transition: 'all 0.3s',
                          opacity: trialForm.visitTime === 'Open 24 Hours' ? 0.7 : 1,
                          width: '100%',
                          boxSizing: 'border-box'
                        }}
                      >
                        {trialForm.visitTime ? (
                          trialForm.visitTime === 'Open 24 Hours' ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', background: '#e0f2fe', padding: '0.3rem 0.6rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 700, color: '#0369a1' }}>
                              🕒 Open 24 Hours
                            </div>
                          ) : (
                            trialForm.visitTime.split(' | ').map((part, idx) => (
                              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', background: '#e0f2fe', padding: '0.3rem 0.6rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 600, color: '#0369a1' }}>
                                {part}
                              </div>
                            ))
                          )
                        ) : (
                          <span style={{ color: '#94a3b8', fontSize: '0.875rem' }}>Select available days/times</span>
                        )}
                      </div>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem', cursor: 'pointer', fontSize: '0.85rem', color: '#475569', fontWeight: 600 }}>
                        <input
                          type="checkbox"
                          checked={trialForm.visitTime === 'Open 24 Hours'}
                          onChange={(e) => {
                            if (e.target.checked) {
                              // Reset the slots state directly without triggering updateVisitTimeString form update
                              setVisitTimes({
                                'Monday': [], 'Tuesday': [], 'Wednesday': [], 'Thursday': [],
                                'Friday': [], 'Saturday': [], 'Sunday': []
                              });
                              setTrialForm(prev => ({ ...prev, visitTime: 'Open 24 Hours' }));
                            } else {
                              setTrialForm(prev => ({ ...prev, visitTime: '' }));
                            }
                          }}
                          style={{ width: '16px', height: '16px', accentColor: '#6366f1' }}
                        />
                        Open 24 Hours
                      </label>
                      {trialErrors.visitTime && trialTouched.visitTime && (
                        <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '4px' }}>{trialErrors.visitTime}</span>
                      )}
                    </div>
                    <div className="input-group" style={{ gridColumn: 'span 2' }}>
                      <label>💬 About</label>
                      <textarea rows="2" name="about" placeholder="Tell us about yourself..." value={trialForm.about} onChange={handleTrialChange}></textarea>
                    </div>

                    <div style={{ gridColumn: 'span 2', display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginTop: '0.75rem', marginBottom: '1.25rem' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', fontSize: '0.9rem', color: 'var(--text-main)', fontWeight: 600 }}>
                        <span>Has Medical</span>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', cursor: 'pointer' }}>
                          <input type="radio" name="hasMedical" value="yes" checked={trialForm.hasMedical === 'yes'} onChange={handleTrialChange} /> Yes
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', cursor: 'pointer' }}>
                          <input type="radio" name="hasMedical" value="no" checked={trialForm.hasMedical === 'no'} onChange={handleTrialChange} /> No
                        </label>
                      </div>
                    </div>

                    {verifyStep === 'initial' && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        style={{ gridColumn: 'span 2', justifyContent: 'center', marginBottom: '0.8rem' }}
                        onClick={handleContinue}
                        disabled={isSubmittingTrial}
                      >
                        {isSubmittingTrial ? 'Processing...' : 'Continue'}
                      </button>
                    )}

                    {showRegistrationFields && (
                      <div className="registration-container" style={{ gridColumn: 'span 2', marginBottom: '1rem', border: '1px solid #dbeafe', borderRadius: '12px', padding: '1.5rem', background: '#f8fafc' }}>
                        <h4 style={{ marginTop: 0, marginBottom: '1.25rem', color: 'var(--text-main)' }}>User registration fields</h4>
                        <div className="registration-form-grid" style={{ gap: '1rem' }}>

                          {/* Username */}
                          <div className="input-group">
                            <label>👤 Username * (letters only)</label>
                            <input type="text" name="username" placeholder="Enter username" value={registerForm.username} onChange={handleRegisterChange} style={{ borderColor: registerErrors.username ? '#EF4444' : '#E2E8F0', background: registerErrors.username ? '#fef2f2' : '#F8FAFC' }} />
                            {registerErrors.username && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>❌ {registerErrors.username}</span>}
                          </div>

                          {/* First Name */}
                          <div className="input-group">
                            <label>✍️ First Name * (letters only)</label>
                            <input type="text" name="firstName" placeholder="Enter first name" value={registerForm.firstName} onChange={handleRegisterChange} style={{ borderColor: registerErrors.firstName ? '#EF4444' : '#E2E8F0', background: registerErrors.firstName ? '#fef2f2' : '#F8FAFC' }} />
                            {registerErrors.firstName && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>❌ {registerErrors.firstName}</span>}
                          </div>

                          {/* Last Name */}
                          <div className="input-group">
                            <label>✍️ Last Name * (letters only)</label>
                            <input type="text" name="lastName" placeholder="Enter last name" value={registerForm.lastName} onChange={handleRegisterChange} style={{ borderColor: registerErrors.lastName ? '#EF4444' : '#E2E8F0', background: registerErrors.lastName ? '#fef2f2' : '#F8FAFC' }} />
                            {registerErrors.lastName && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>❌ {registerErrors.lastName}</span>}
                          </div>

                          {/* Email */}
                          <div className="input-group">
                            <label>📧 Email *</label>
                            <input type="email" name="email" placeholder="email@example.com" value={registerForm.email} onChange={handleRegisterChange} style={{ borderColor: registerErrors.email ? '#EF4444' : '#E2E8F0', background: registerErrors.email ? '#fef2f2' : '#F8FAFC' }} />
                            {registerErrors.email && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>❌ {registerErrors.email}</span>}
                          </div>

                          {/* Password with Strength Indicator */}
                          <div className="input-group" style={{ gridColumn: 'span 2' }}>
                            <label>🔐 Password *</label>
                            <input type="password" name="password" placeholder="Min 8 characters" value={registerForm.password} onChange={handleRegisterChange} style={{ borderColor: registerErrors.password ? '#EF4444' : '#E2E8F0', background: registerErrors.password ? '#fef2f2' : '#F8FAFC' }} />
                            {registerForm.password && (
                              <div style={{ marginTop: '0.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.75rem', marginBottom: '0.5rem' }}>
                                  <span>Strength:</span>
                                  <div style={{ width: '100px', height: '4px', background: '#e5e7eb', borderRadius: '2px', overflow: 'hidden' }}>
                                    <div style={{ width: `${(passwordStrength.strength / 5) * 100}%`, height: '100%', background: getPasswordStrengthColor(), transition: 'all 0.3s' }}></div>
                                  </div>
                                  <span style={{ color: getPasswordStrengthColor(), fontWeight: 600 }}>{getPasswordStrengthText()}</span>
                                </div>
                                <div style={{ fontSize: '0.7rem', lineHeight: '1.4' }}>
                                  <div style={{ color: passwordStrength.criteria.length ? '#22C55E' : '#9ca3af' }}>
                                    {passwordStrength.criteria.length ? '✅' : '⭕'} At least 8 characters
                                  </div>
                                  <div style={{ color: passwordStrength.criteria.uppercase ? '#22C55E' : '#9ca3af' }}>
                                    {passwordStrength.criteria.uppercase ? '✅' : '⭕'} At least one uppercase letter (A-Z)
                                  </div>
                                  <div style={{ color: passwordStrength.criteria.lowercase ? '#22C55E' : '#9ca3af' }}>
                                    {passwordStrength.criteria.lowercase ? '✅' : '⭕'} At least one lowercase letter (a-z)
                                  </div>
                                  <div style={{ color: passwordStrength.criteria.number ? '#22C55E' : '#9ca3af' }}>
                                    {passwordStrength.criteria.number ? '✅' : '⭕'} At least one number (0-9)
                                  </div>
                                  <div style={{ color: passwordStrength.criteria.special ? '#22C55E' : '#9ca3af' }}>
                                    {passwordStrength.criteria.special ? '✅' : '⭕'} At least one special character (!@#$%^&*)
                                  </div>
                                </div>
                              </div>
                            )}
                            {registerErrors.password && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>❌ {registerErrors.password}</span>}
                          </div>

                          {/* Confirm Password */}
                          <div className="input-group" style={{ gridColumn: 'span 2' }}>
                            <label>🔐 Confirm Password *</label>
                            <input type="password" name="confirmPassword" placeholder="Re-enter password" value={registerForm.confirmPassword} onChange={handleRegisterChange} style={{ borderColor: registerErrors.confirmPassword ? '#EF4444' : '#E2E8F0', background: registerErrors.confirmPassword ? '#fef2f2' : '#F8FAFC' }} />
                            {registerForm.confirmPassword && !registerErrors.confirmPassword && (
                              <span style={{ color: '#22C55E', fontSize: '0.75rem', marginTop: '2px' }}>✅ Passwords match</span>
                            )}
                            {registerErrors.confirmPassword && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '2px' }}>❌ {registerErrors.confirmPassword}</span>}
                          </div>

                          {/* Role */}
                          <div className="input-group" style={{ gridColumn: 'span 2' }}>
                            <label>👥 Role</label>
                            <input type="text" name="role" placeholder="e.g. 1" value={registerForm.role} onChange={handleRegisterChange} style={{ borderColor: '#E2E8F0', background: '#F8FAFC' }} />
                          </div>
                        </div>
                      </div>
                    )}

                    {verifyStep === 'verified' && (
                      <button type="submit" className="btn btn-primary" style={{ gridColumn: 'span 2', justifyContent: 'center' }} disabled={isSubmittingTrial}>
                        {isSubmittingTrial ? 'Registering...' : 'Register User'}
                      </button>
                    )}

                    {serverError && (
                      <div style={{ gridColumn: 'span 2', background: '#fee2e2', color: '#991b1b', padding: '0.75rem', borderRadius: '8px', fontSize: '0.85rem', textAlign: 'center' }}>
                        ⚠️ {serverError}
                      </div>
                    )}

                    {verificationMessage && (
                      <div style={{ gridColumn: 'span 2', background: '#ebf8ff', color: '#1d4ed8', padding: '0.75rem', borderRadius: '8px', fontSize: '0.85rem', textAlign: 'center' }}>
                        ✅ {verificationMessage}
                      </div>
                    )}

                    {pendingClinicId && verifyStep !== 'verified' && (
                      <div style={{ gridColumn: 'span 2', background: '#f8fafc', padding: '1rem', borderRadius: '12px', border: '1px solid #e2e8f0', marginTop: '0.5rem' }}>
                        <h4 style={{ margin: '0 0 0.5rem 0' }}>Verify your clinic email</h4>
                        <p style={{ fontSize: '0.8rem', color: '#334155' }}>
                          Enter the code sent to <strong>{trialForm.email}</strong> to complete registration.
                        </p>
                        <div style={{ display: 'flex', gap: '0.6rem', marginTop: '0.6rem' }}>
                          <input
                            type="text"
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, ''))}
                            placeholder="Enter code"
                            maxLength={6}
                            style={{ flex: 1, padding: '0.6rem 0.75rem', borderRadius: '8px', border: '1px solid #cbd5e1' }}
                          />
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleConfirmCode}
                            disabled={isSubmittingTrial || !verificationCode.trim()}
                          >
                            {isSubmittingTrial ? 'Verifying...' : 'Verify'}
                          </button>
                        </div>
                        <button
                          type="button"
                          className="btn"
                          style={{ marginTop: '0.6rem', border: '1px solid #cbd5e1', background: 'white', color: '#0f172a' }}
                          onClick={handleResendCode}
                          disabled={isSubmittingTrial}
                        >
                          Resend code
                        </button>
                      </div>
                    )}

                    {trialSuccess && verifyStep === 'verified' && (
                      <div style={{ gridColumn: 'span 2', background: '#dcfce7', color: '#166534', padding: '1rem', borderRadius: '12px', fontSize: '0.9rem', textAlign: 'center', border: '1px solid #bbf7d0' }}>
                        <div style={{ marginBottom: '0.75rem' }}>🎉 Clinic registered and email verified!</div>
                        <a
                          href="https://clinicpulseadmin.netlify.app/login"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary"
                          style={{ fontSize: '0.85rem', padding: '0.6rem 1.2rem' }}
                        >
                          Go to Dashboard
                        </a>
                      </div>
                    )}

                    <p style={{ gridColumn: 'span 2', textAlign: 'center', fontSize: '0.7rem', color: 'var(--text-muted)', marginTop: '0.5rem' }}>
                      🛡️ Your information is secure
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" style={{ background: '#F8FAFC' }}>
          <div className="container">
            <div className="section-header">
              <h2>Get in <span className="gradient-text">Touch</span></h2>
              <p>Have questions? Our team is here to help you get started with ClinicPulse.</p>
            </div>

            <div className="contact-split">
              <div className="contact-info-card">
                <InfoItem
                  icon={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>}
                  label="Email Us"
                  text="clinicpulsesupport@gmail.com"
                />
                <InfoItem
                  icon={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>}
                  label="Call Us"
                  text="+91 9003665586"
                />
                <InfoItem
                  icon={<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>}
                  label="Live Chat"
                  text="Available 24/7"
                />

                <div style={{ marginTop: '2rem' }}>
                  <p style={{ fontWeight: 600, marginBottom: '1rem' }}>Follow Us</p>
                  <div className="social-links">
                    <div className="social-icon"><svg width="18" height="18" fill="white" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg></div>
                    <a href="https://www.linkedin.com/in/clinic-pulse-app" target="_blank" rel="noopener noreferrer" className="social-icon">
                      <svg width="18" height="18" fill="white" viewBox="0 0 24 24">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                      </svg>
                    </a>
                    <a href="https://instagram.com/clinicpulse_app/" target="_blank" rel="noopener noreferrer" className="social-icon">
                      <svg width="18" height="18" fill="white" viewBox="0 0 24 24">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.332 3.608 1.308.975.975 1.245 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.063 1.366-.333 2.633-1.308 3.608-.975.975-2.242 1.245-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.063-2.633-.333-3.608-1.308-.975-.975-1.245-2.242-1.308-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.332-2.633 1.308-3.608.975-.975 2.242-1.245 3.608-1.308 1.266-.058 1.646-.07 4.85-.07zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948s.014 3.667.072 4.947c.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072s3.667-.014 4.947-.072c4.358-.2 6.78-2.618 6.98-6.98.058-1.281.072-1.689.072-4.948s-.014-3.667-.072-4.947c-.2-4.358-2.618-6.78-6.98-6.98-1.28-.059-1.688-.073-4.947-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>
                    </a>
                    <a href="https://wa.me/15551952193" target="_blank" rel="noopener noreferrer" className="social-icon">
                      <svg width="18" height="18" fill="white" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <div style={{ background: 'white', padding: '1.5rem', borderRadius: '24px', boxShadow: 'var(--shadow-xl)', border: '1px solid #f1f5f9' }}>
                <form style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                  <div className="input-group">
                    <label>Name *</label>
                    <input type="text" placeholder="Your full name" />
                  </div>
                  <div className="input-group">
                    <label>Email *</label>
                    <input type="email" placeholder="your@email.com" />
                  </div>
                  <div className="input-group">
                    <label>Clinic Name</label>
                    <input type="text" placeholder="Your clinic name" />
                  </div>
                  <div className="input-group">
                    <label>📱 Phone *</label>
                    <div style={{ display: 'flex', gap: '0.4rem' }}>
                      <select
                        value={contactCountry.code}
                        onChange={(e) => {
                          const country = countryList.find(c => c.code === e.target.value);
                          setContactCountry(country || countryList[1]);
                        }}
                        style={{ width: '85px', padding: '0.6rem 0.5rem', borderRadius: '8px', border: '1px solid #E2E8F0', background: '#F8FAFC', fontSize: '0.8rem' }}
                      >
                        {countryList.map(country => (
                          <option key={country.code} value={country.code}>
                            {country.code} {country.name}
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        placeholder="Phone number"
                        value={contactPhone}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, '');
                          if (val.length <= contactCountry.maxLength) setContactPhone(val);
                        }}
                        style={{ flex: 1 }}
                      />
                    </div>
                    <span style={{ fontSize: '0.75rem', color: '#64748B', marginTop: '2px' }}>
                      {contactPhone.length}/{contactCountry.maxLength} digits
                    </span>
                  </div>
                  <div className="input-group" style={{ gridColumn: 'span 2' }}>
                    <label>Subject *</label>
                    <select>
                      <option>Select a subject</option>
                      <option>General Inquiry</option>
                      <option>Support</option>
                      <option>Sales</option>
                    </select>
                  </div>
                  <div className="input-group" style={{ gridColumn: 'span 2' }}>
                    <label>Message *</label>
                    <textarea rows="2" placeholder="Tell us how we can help you..."></textarea>
                  </div>
                  <button className="btn btn-primary" style={{ gridColumn: 'span 2', justifyContent: 'center' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '8px' }}><line x1="22" y1="2" x2="11" y2="13"></line><polyline points="22 2 15 22 11 13 2 9 22 2"></polyline></svg>
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer>
          <div className="container">
            <div className="footer-grid">
              <div>

                <p className="footer-desc">
                  ClinicPulse is a clinic management software in India that offers patient-centric features to streamline healthcare operations and enhance patient care.
                </p>
              </div>

              <div className="footer-links">
                <h4>ClinicPulse</h4>
                <ul>
                  <li><a href="#features">Features</a></li>
                  <li><a href="#how-it-works">How it Works</a></li>
                  <li><a href="#testimonials">Testimonials</a></li>
                  <li><a href="#contact">Contact</a></li>
                  <li><a href="#trial">Register</a></li>
                </ul>
              </div>

              <div className="footer-links">
                <h4>Resources</h4>
                <ul>
                  <li><a href="#about" onClick={(e) => { e.preventDefault(); setShowAboutModal(true); }}>About Us</a></li>
                  <li><a href="#terms" onClick={(e) => { e.preventDefault(); setShowTermsModal(true); }}>Terms & Conditions</a></li>
                  <li><a href="#privacy" onClick={(e) => { e.preventDefault(); setShowPrivacyModal(true); }}>Privacy Policy</a></li>
                  <li><a href="#support" onClick={(e) => { e.preventDefault(); setShowSupportModal(true); }}>Support</a></li>
                </ul>
              </div>

              <div className="footer-links">
                <h4>Socials</h4>
                <ul className="social-list">
                  <li><a href="https://wa.me/15551952193" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
                  <li><a href="https://instagram.com/clinicpulse_app/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                  <li><a href="https://www.linkedin.com/in/clinic-pulse-app" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                </ul>
              </div>
            </div>
            <div className="footer-bottom">
              <div className="footer-meta">
                <span>© 2026 ClinicPulse Inc. All rights reserved.</span>
                <div className="footer-meta-links">
                  <a href="#support" onClick={(e) => { e.preventDefault(); setShowSupportModal(true); }}>Support</a>
                  <a href="#contact">Help Center</a>
                </div>
              </div>
            </div>
          </div>
        </footer>

        {showVideo && (
          <div className="video-modal-overlay" onClick={() => setShowVideo(false)}>
            <div className="video-modal-container" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close-btn" onClick={() => setShowVideo(false)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              <video
                className="video-player"
                controls
                autoPlay
                src="/cpvideo.mp4"
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        )}

        {showDemoModal && (
          <div className="video-modal-overlay" onClick={() => setShowDemoModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '450px',
              width: '95%',
              padding: '2.5rem',
              textAlign: 'left',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowDemoModal(false)}
                style={{ color: '#64748b', position: 'absolute', top: '1.5rem', right: '1.5rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
                <h2 style={{ fontSize: '1.8rem', marginBottom: '0.5rem' }}>Schedule <span className="gradient-text">Demo</span></h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Fill in your details and we'll be in touch.</p>
              </div>

              <form
                noValidate
                style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}
                onSubmit={handleDemoSubmit}
              >
                <div className="input-group">
                  <label style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b', marginBottom: '0.4rem', display: 'block' }}>🏢 Clinic Name *</label>
                  <input type="text" placeholder="Enter your clinic name" required disabled={isSubmittingDemo} value={demoName} onChange={(e) => { setDemoName(e.target.value.replace(/[^a-zA-Z\s]/g, '')); setDemoSubmitted(false); }} style={{ width: '100%', boxSizing: 'border-box', padding: '0.75rem', borderRadius: '8px', border: '1px solid', borderColor: demoSubmitted && !demoName ? '#EF4444' : '#e2e8f0', background: '#F8FAFC' }} />
                  {demoSubmitted && !demoName && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '4px', display: 'block' }}>Please enter your Clinic Name.</span>}
                </div>
                <div className="input-group">
                  <label style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b', marginBottom: '0.4rem', display: 'block' }}>📱 Phone Number *</label>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <select
                      value={demoCountry.code}
                      disabled={isSubmittingDemo}
                      onChange={(e) => {
                        const country = countryList.find(c => c.code === e.target.value);
                        setDemoCountry(country || countryList[1]);
                        if (demoPhone.length > (country?.maxLength || countryList[1].maxLength)) {
                          setDemoPhone(demoPhone.slice(0, country.maxLength));
                        }
                      }}
                      style={{ width: '40%', padding: '0.75rem 0.5rem', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#F8FAFC', fontSize: '0.85rem' }}
                    >
                      {countryList.map(country => (
                        <option key={country.code} value={country.code}>
                          {country.code} {country.name}
                        </option>
                      ))}
                    </select>
                    <input
                      type="tel"
                      placeholder="Enter your phone number"
                      required
                      disabled={isSubmittingDemo}
                      value={demoPhone}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, '');
                        if (val.length <= demoCountry.maxLength) setDemoPhone(val);
                        setDemoSubmitted(false);
                      }}
                      style={{ width: '60%', boxSizing: 'border-box', padding: '0.75rem', borderRadius: '8px', border: '1px solid', borderColor: demoSubmitted && !demoPhone ? '#EF4444' : '#e2e8f0', background: '#F8FAFC' }}
                    />
                  </div>
                  {demoSubmitted && !demoPhone && <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '4px', display: 'block' }}>Please enter your Phone Number.</span>}
                </div>
                <div className="input-group">
                  <label style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b', marginBottom: '0.4rem', display: 'block' }}>✉️ Email Address (Optional)</label>
                  <input type="email" placeholder="example@domain.com" disabled={isSubmittingDemo} value={demoEmail} onChange={(e) => setDemoEmail(e.target.value)} style={{ width: '100%', boxSizing: 'border-box', padding: '0.75rem', borderRadius: '8px', border: '1px solid', borderColor: demoEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(demoEmail) ? '#EF4444' : '#e2e8f0', background: '#F8FAFC' }} />
                  {demoEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(demoEmail) && (
                    <span style={{ color: '#EF4444', fontSize: '0.75rem', marginTop: '4px', display: 'block' }}>
                      {!demoEmail.includes('@')
                        ? "Email is missing an '@' symbol."
                        : demoEmail.split('@')[1].trim() === ''
                          ? "Please enter a domain name after the '@'."
                          : !demoEmail.split('@')[1].includes('.')
                            ? "Email is missing a domain extension (like .com)."
                            : "Please enter a valid email address format."}
                    </span>
                  )}
                </div>
                {demoError && (
                  <div style={{ background: '#fef2f2', color: '#EF4444', padding: '0.75rem', borderRadius: '8px', fontSize: '0.85rem', border: '1px solid #fee2e2', textAlign: 'center' }}>
                    ⚠️ {demoError}
                  </div>
                )}
                <button type="submit" className="btn btn-primary" disabled={isSubmittingDemo} style={{ marginTop: '0.5rem', justifyContent: 'center', width: '100%', opacity: isSubmittingDemo ? 0.7 : 1 }}>
                  {isSubmittingDemo ? 'Submitting...' : 'Request Demo'}
                </button>
              </form>
            </div>
          </div>
        )}

        {showAboutModal && (
          <div className="video-modal-overlay" onClick={() => setShowAboutModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '550px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2rem',
              textAlign: 'center',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowAboutModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src="/logo_square.png" alt="ClinicPulse Logo" style={{ width: 150, height: 150, borderRadius: '12px', marginBottom: '1rem' }} />
              </div>

              <div style={{
                padding: '1.5rem',
                background: '#E8F9F1',
                borderRadius: '16px',
                border: '1px solid #C1F5DC',
                marginBottom: '2rem'
              }}>
                <p style={{ fontSize: '0.9rem', color: '#047857', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.5rem' }}>Our Motto</p>
                <h3 style={{ fontSize: '1.5rem', color: '#0366D6', margin: 0 }}>"{motto}"</h3>
              </div>

              <div style={{ textAlign: 'left' }}>
                <h4 style={{ color: '#0366D6', fontSize: '1.1rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
                  Our Mission
                </h4>
                <p style={{ color: '#475569', lineHeight: 1.7, marginBottom: '1.25rem', fontSize: '0.95rem' }}>
                  We are on a mission to make high-quality clinic management affordable, secure, and effortlessly smart for clinics worldwide. We believe that by automating appointments, digitizing records, and simplifying billing, we free up doctors and staff to focus on what truly matters: <strong>patient health.</strong>
                </p>
                <p style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                  We want information exchange between clinics, patients, and labs to be transparent, fast, and secure.
                </p>

                <h4 style={{ color: '#0366D6', fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  Our Background
                </h4>
                <p style={{ color: '#475569', lineHeight: 1.7, marginBottom: '1rem', fontSize: '0.95rem' }}>
                  We are a team of healthcare practitioners, tech innovators, and data security experts who were tired of seeing clinics drown in paperwork and manual follow-ups. We built ClinicPulse to be the only platform a modern clinic needs.
                </p>
                <div style={{ fontStyle: 'italic', color: '#64748b', fontSize: '0.9rem', borderLeft: '4px solid #10B981', paddingLeft: '1rem', marginTop: '1rem' }}>
                  "From a small clinic to a large multi-specialty hospital, ClinicPulse grows with you. We're not just software; we're your efficiency partner."
                </div>
              </div>
            </div>
          </div>
        )}

        {showPrivacyModal && (
          <div className="video-modal-overlay" onClick={() => setShowPrivacyModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '800px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2.5rem',
              textAlign: 'left',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowPrivacyModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '2.5rem', textAlign: 'center' }}>
                <img src="/heart_logo.jpg" alt="Logo" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '1rem' }} />
                <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Privacy <span className="gradient-text">Policy</span></h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Last Updated: April 10, 2026</p>
              </div>

              <div style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                <p style={{ marginBottom: '1.5rem' }}>
                  <strong>ClinicPulse Technologies</strong> ("ClinicPulse", "Company", "we", "us", or "our") owns and operates the website clinicpulse.org (the "Site"). ClinicPulse is committed to protecting your privacy and the security of your health and business information.
                </p>
                <p style={{ marginBottom: '1.5rem' }}>
                  This Privacy Policy explains how we collect, use, share, and protect the personal data of our users, including clinic administrators, doctors, staff, and patients.
                </p>
                <p style={{ marginBottom: '1.5rem', fontStyle: 'italic' }}>
                  Our privacy policy is subject to change at any time without notice. To make sure you are aware of any changes, please review this policy periodically.
                </p>

                <p style={{ fontWeight: 700, marginBottom: '1rem' }}>This Privacy Policy is published in compliance with:</p>
                <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                  <li>Section 43A of the IT Act, 2000</li>
                  <li>Regulation 4 of the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Information) Rules, 2011 (the "SPI Rules")</li>
                  <li>Regulation 3(1) of the Information Technology (Intermediaries Guidelines) Rules, 2011</li>
                </ul>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>1. Personal Information Collected</h3>
                <p style={{ marginBottom: '1rem' }}>ClinicPulse is the sole owner of the information collected on the Site. We will not sell, share, transfer, or rent your personal information to others in ways different from what is disclosed in this Privacy Policy and our Terms of Service.</p>
                <p style={{ marginBottom: '1rem' }}>We collect information when you:</p>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li>Register for a clinic account</li>
                  <li>Sign up for a free trial</li>
                  <li>Contact our support team</li>
                  <li>Use any of our features (patient management, scheduling, e-prescriptions, billing, telemedicine)</li>
                </ul>
                <p style={{ marginBottom: '1.5rem' }}>Personal information means any information that relates to a natural person, which, either directly or indirectly, is capable of identifying such person.</p>

                <p style={{ fontWeight: 700, marginBottom: '1rem' }}>Sensitive Personal Data (SPI) includes:</p>
                <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                  <li>Passwords</li>
                  <li>Financial information (bank accounts, credit/debit card details)</li>
                  <li>Physical, physiological, and mental health conditions</li>
                  <li>Medical records and history</li>
                  <li>Biometric information</li>
                  <li>Call data records</li>
                </ul>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>2. Note to All Users</h3>
                <div style={{ display: 'grid', gap: '1.5rem' }}>
                  <div>
                    <strong>Account Information:</strong> During registration, you are required to provide your clinic name, email address, phone number, and role.
                  </div>
                  <div>
                    <strong>Patient Data:</strong> You may upload patient health records, medical histories, etc. This data is stored securely and only accessible to authorized users.
                  </div>
                  <div>
                    <strong>IP Address & Cookies:</strong> We collect IP addresses to diagnose server problems and analyze trends.
                  </div>
                  <div>
                    <strong>Data Security:</strong> ClinicPulse takes complete precautions to keep your information secure. Access is limited to necessary personnel.
                  </div>
                  <div>
                    <strong>No Medical Liability:</strong> ClinicPulse provides tools only. We are not responsible for medical treatment or patient outcomes.
                  </div>
                </div>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>3. Note to Practitioners & Clinics</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Professional Information:</strong> You must provide accurate professional information. Providing false info is grounds for termination.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Patient Data Ownership:</strong> You retain full ownership of all patient medical records. We merely provide storage and management tools.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>4. Data Retention</h3>
                <p>Personal info is retained only as long as necessary. Once the purpose is achieved, data is deleted securely or anonymized for analytics.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>5. Data Deletion Request</h3>
                <p style={{ marginBottom: '1rem' }}>To submit a data deletion request: Email <strong>clinicpulsesupport@gmail.com</strong> with the subject "Data Deletion Request". We process requests within 30 days.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>6. Contact Us</h3>
                <p>Email: clinicpulsesupport@gmail.com<br />Phone: +91 9003665586<br />Live Chat: Available 24/7</p>
              </div>
            </div>
          </div>
        )}

        {showTermsModal && (
          <div className="video-modal-overlay" onClick={() => setShowTermsModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '800px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2.5rem',
              textAlign: 'left',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowTermsModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '2.5rem', textAlign: 'center' }}>
                <img src="/heart_logo.jpg" alt="Logo" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '1rem' }} />
                <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Terms & <span className="gradient-text">Conditions</span></h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Last Updated: April 10, 2026</p>
              </div>

              <div style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                <p style={{ marginBottom: '1.5rem' }}>
                  <strong>ClinicPulse Technologies</strong> ("ClinicPulse", "Company", "we", "us", or "our") owns and operates the website clinicpulse.org and the ClinicPulse mobile application (together, the "Platform"). We provide clinic management software services to clinics, doctors, and healthcare professionals.
                </p>
                <p style={{ marginBottom: '1.5rem' }}>
                  These Terms & Conditions ("Agreement") govern your use of the Platform. By registering for or using ClinicPulse, you agree to be bound by this Agreement.
                </p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>1. About ClinicPulse</h3>
                <p style={{ marginBottom: '1rem' }}>ClinicPulse provides the following services:</p>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li><strong>Patient Management</strong> – Comprehensive digital health records with quick access to medical history, allergies, and lab results.</li>
                  <li><strong>Smart Scheduling</strong> – Reduce no-shows with automated appointment reminders and an intuitive drag-and-drop calendar.</li>
                  <li><strong>E-Prescriptions</strong> – Send prescriptions directly to pharmacies securely. Minimize errors and improve patient safety.</li>
                  <li><strong>Automated Billing</strong> – Easy invoicing and insurance claim processing. Get paid faster with integrated payment gateways.</li>
                  <li><strong>Advanced Analytics</strong> – Get detailed insights into clinic performance, patient trends, and financial growth with real-time dashboards.</li>
                  <li><strong>Telemedicine</strong> – Provide virtual consultations securely. Integrated high-quality video calling and session recording for remote care.</li>
                  <li><strong>Role-Based Access</strong> – Define roles for efficient task management (doctors, staff, admins).</li>
                </ul>
                <p style={{ marginBottom: '1.5rem' }}><strong>Support:</strong> Our tech support team is available 24/7 via live chat and email at clinicpulsesupport@gmail.com. Phone support is available at +91 9003665586.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>2. Definitions</h3>
                <p style={{ marginBottom: '1rem' }}><strong>"ClinicPulse"</strong> means the software created by ClinicPulse Technologies that is provided to users on a subscription basis.</p>
                <p style={{ marginBottom: '1rem' }}><strong>"Clinic" or "Doctor" or "You"</strong> means the healthcare provider, clinic, or professional registering for and using the Platform.</p>
                <p style={{ marginBottom: '1rem' }}><strong>"Patient" or "Customer"</strong> means the end patient whose data is stored and managed through the Platform.</p>
                <p style={{ marginBottom: '1rem' }}><strong>"Updates"</strong> means enhancements, bug fixes, and new versions made to ClinicPulse.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>"HIPAA Verified"</strong> means the Platform adheres to security and privacy standards consistent with HIPAA requirements.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>3. License Grant and Access to Software</h3>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Subscription License:</strong> Subject to all limitations herein, ClinicPulse grants you a SaaS (Software as a Service), limited, revocable, non-exclusive, and non-transferable right to access and use ClinicPulse as hosted by us.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Account Creation:</strong> You will be provided with login credentials to create a Clinic Account. You are responsible for maintaining the confidentiality of your login details.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Eligibility:</strong> Only persons who can form legally binding contracts under the Indian Contract Act, 1872 may use the Platform. If you are a minor (under 18 years), you may use the Platform only under the supervision of a parent or legal guardian. We reserve the right to terminate your membership if you are incompetent to contract.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Limitation on Use:</strong> ClinicPulse may be used by you for management of one clinic location per subscription unless you purchase a multi-location plan.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Customization:</strong> ClinicPulse has the sole right to modify features, add new functionality, or customize the Platform at its discretion.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Data Responsibility:</strong> You are solely responsible for the accuracy and completeness of all patient information you upload. You must maintain backup copies of your data. We will assist in restoring data from your last available backup in compatible format.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Prohibited Actions:</strong> You may not disassemble, decompile, reverse engineer, or copy ClinicPulse. You may not resell, sublicense, rent, or transfer your access to any third party.</li>
                  <li><strong>Authorized Users:</strong> Authorized users consist of your employees and contractors who do not compete with ClinicPulse. You are fully liable for their acts and omissions.</li>
                </ul>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>4. Technical Support</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Support Availability:</strong> We provide support 24/7 via live chat on our website and email at clinicpulsesupport@gmail.com. Phone support is available at +91 9003665586 (Monday–Saturday, 10 AM – 7 PM IST, excluding public holidays).</p>
                <p style={{ marginBottom: '1rem' }}><strong>Response Times:</strong> Response times vary based on issue severity. Critical issues affecting core functionality will be prioritized.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Electronic Communications:</strong> By using the Platform, you consent to receive communications from us via electronic records, including emails, notifications, and updates.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>5. Telemedicine Services</h3>
                <p style={{ marginBottom: '1rem' }}>Telemedicine consultations are between you and your patients. A consent form must be agreed to by patients before any telemedicine consultation.</p>
                <p style={{ marginBottom: '1rem' }}>ClinicPulse is not liable for any legal issues arising from telemedicine consultations or data shared between you and your patients.</p>
                <p style={{ marginBottom: '1rem' }}>We are not responsible for interruptions in communication due to technical or network failures.</p>
                <p style={{ marginBottom: '1.5rem' }}>All interactions during telemedicine consultations are strictly between you and your patient and are subject to doctor-patient confidentiality.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>6. Payments, Refund, and Cancellation</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Payments:</strong> Subscription fees for ClinicPulse must be paid in accordance with the plan you select. All applicable taxes are your responsibility.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Payment Collection:</strong> Any money collected from patients through our billing features is your liability. ClinicPulse only facilitates the payment process and is not liable for payment disputes, failures, or chargebacks.</p>
                <p style={{ marginBottom: '1rem' }}><strong>No Guarantee:</strong> ClinicPulse does not guarantee that using the Platform will generate any specific revenue or business for your clinic.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Refund Policy:</strong> Given the digital nature of our services, refunds are not granted unless required under applicable consumer protection laws. We will assess refund requests on their merits.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Cancellation:</strong> Cancellations can be requested by emailing clinicpulsesupport@gmail.com within 48 hours of purchase. Refunds, if approved, will be processed within 14 days using the same payment method used for purchase.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>7. Confidentiality</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Confidential Information:</strong> Both parties agree to retain in confidence all information disclosed that is designated as confidential. This Agreement's terms are considered Confidential Information.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Exclusions:</strong> Confidential Information does not include information that becomes publicly available through no fault of either party, or that was independently developed.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Protection:</strong> Each party will protect the other's Confidential Information using reasonable precautions. Confidentiality obligations survive termination of this Agreement for three (3) years. Trade secrets remain protected indefinitely.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Your Data:</strong> Any data you provide to ClinicPulse will be protected and accessed only with your permission, governed by our Privacy Policy.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>8. Representations and Warranties</h3>
                <p style={{ marginBottom: '0.5rem', fontWeight: 700 }}>By You (Clinic/Doctor): You represent and warrant that:</p>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li>You are 18 years or older and have the authority to enter into this Agreement.</li>
                  <li>You will not transfer your account or login credentials to any third party.</li>
                  <li>All information you upload is true, accurate, and complete.</li>
                  <li>You have necessary rights from patients to upload their health records.</li>
                  <li>You will not use ClinicPulse for any unlawful purpose.</li>
                  <li>You will not interfere with or disrupt the Platform or its servers.</li>
                  <li>You will comply with all applicable laws.</li>
                </ul>
                <p style={{ marginBottom: '1rem' }}><strong>By ClinicPulse:</strong> The Platform is provided "as is" and "as available". We make no express or implied warranties about merchantability, fitness for a particular purpose, or non-infringement.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Disclaimer of Warranties:</strong><br />USE OF THE PLATFORM IS AT YOUR OWN RISK. CLINICPULSE MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND. WE DISCLAIM ALL WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE PLATFORM WILL OPERATE WITHOUT INTERRUPTION OR ERROR.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Limitation of Liability:</strong><br />TO THE MAXIMUM EXTENT PERMITTED BY LAW, CLINICPULSE SHALL NOT BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, PUNITIVE, OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OR INABILITY TO USE THE PLATFORM, INCLUDING LOSS OF PROFITS, DATA, OR BUSINESS INTERRUPTION.</p>
                <p style={{ marginBottom: '1rem' }}><strong>No Medical Liability:</strong> ClinicPulse provides management software only. We are not responsible for the quality of medical treatment, diagnoses, prescriptions, or patient outcomes. You remain solely responsible for all medical decisions.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Third Parties:</strong> We are not responsible for unauthorized access to your data, third-party services, or any threatening, defamatory, or illegal conduct of others.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Force Majeure:</strong> We shall not be liable for any downtime or delay caused by circumstances beyond our reasonable control, including cyber-attacks, acts of God, pandemics, floods, earthquakes, strikes, or internet service provider failures.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>9. Term and Termination</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Term:</strong> This Agreement remains in effect for one (1) year and automatically renews for successive one-year periods unless either party gives 60 days' notice before the renewal date.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Termination for Cause:</strong> Either party may terminate if the other party breaches a material obligation and fails to cure within 30 days of notice.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Termination by ClinicPulse for Convenience:</strong> We may terminate this Agreement by providing 90 days' written notice if we determine it is no longer feasible to support the Platform.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Effect of Termination:</strong> Upon termination, we will provide you with a complete export of your database in electronic format within a reasonable time, and your account will be deactivated.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>10. Sharing of Information with Affiliates</h3>
                <p style={{ marginBottom: '1.5rem' }}>We may share your information with our affiliates if required to provide the services you requested. This includes patient health records and other data.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>11. General Provisions</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Assignment:</strong> You may not assign this Agreement without our prior written consent.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Waiver:</strong> Failure to enforce any right does not constitute a waiver.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Notices:</strong> All notices shall be in writing and sent to the email address or physical address provided.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Independent Parties:</strong> Neither party is an agent or employee of the other. No party has authority to bind the other.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Loss of Data:</strong> We are not responsible for data lost due to your negligence.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Governing Law & Arbitration:</strong> This Agreement shall be governed by the laws of India. Any disputes shall be settled by arbitration in accordance with the Arbitration and Conciliation Act, 1996. The place of arbitration shall be [Your City, e.g., Chennai or Mumbai]. The language of arbitration shall be English.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Entire Agreement:</strong> This Agreement constitutes the entire agreement between the parties and supersedes all prior communications.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>12. Contact Us</h3>
                <p>Email: clinicpulsesupport@gmail.com<br />Phone: +91 9003665586<br />Live Chat: Available 24/7 on our website</p>
              </div>
            </div>
          </div>
        )}

        {showSupportModal && (
          <div className="video-modal-overlay" onClick={() => setShowSupportModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '600px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2.5rem',
              textAlign: 'left',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowSupportModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                  <div style={{ width: '60px', height: '60px', background: '#E8F9F1', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10B981' }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  </div>
                </div>
                <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                  <img src="/heart_logo.jpg" alt="Logo" style={{ width: '40px', height: '40px', borderRadius: '8px' }} />
                  ClinicPulse <span className="gradient-text">Support</span>
                </h2>
                <p style={{ color: '#64748b', fontSize: '0.95rem' }}>We're here to help you succeed.</p>
              </div>

              <div style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                <h3 style={{ color: '#0366D6', marginBottom: '1.25rem', fontSize: '1.1rem', borderBottom: '1px solid #e2e8f0', paddingBottom: '0.5rem' }}>Technical Support Availability:</h3>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <div style={{ marginTop: '2px', color: '#3B82F6' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                    </div>
                    <div>
                      <strong style={{ display: 'block', color: '#1e293b' }}>Live Chat:</strong>
                      <span>24/7 on our website</span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <div style={{ marginTop: '2px', color: '#3B82F6' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    </div>
                    <div>
                      <strong style={{ display: 'block', color: '#1e293b' }}>Email Support:</strong>
                      <span>clinicpulsesupport@gmail.com </span>
                      <span style={{ fontSize: '0.85rem', color: '#10B981', display: 'block', marginTop: '2px' }}>(Response within 24 hours)</span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <div style={{ marginTop: '2px', color: '#3B82F6' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    </div>
                    <div>
                      <strong style={{ display: 'block', color: '#1e293b' }}>Phone Support:</strong>
                      <span>+91 9003665586</span>
                      <span style={{ fontSize: '0.85rem', color: '#64748b', display: 'block', marginTop: '2px' }}>(Monday–Saturday, 10:00 AM – 7:00 PM IST)</span>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: '2rem', padding: '1.25rem', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                  <div style={{ marginBottom: '1rem' }}>
                    <strong style={{ color: '#0f172a' }}>📅 Support Holidays:</strong>
                    <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>Phone support not available on public holidays. Email and chat remain available.</p>
                  </div>
                  <div>
                    <strong style={{ color: '#0f172a' }}>🎫 Ticket System:</strong>
                    <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>For critical issues, you can raise a support ticket via email. We will respond based on the severity of the issue.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showAboutModal && (
          <div className="video-modal-overlay" onClick={() => setShowAboutModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '550px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2rem',
              textAlign: 'center',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowAboutModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '1.5rem' }}>
                <img src="/heart_logo.jpg" alt="Logo" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '1rem' }} />
                <h2 style={{ fontSize: '1.75rem', marginBottom: '0.5rem' }}>About <span className="gradient-text">ClinicPulse</span></h2>
              </div>

              <div style={{
                padding: '1.5rem',
                background: '#E8F9F1',
                borderRadius: '16px',
                border: '1px solid #C1F5DC',
                marginBottom: '2rem'
              }}>
                <p style={{ fontSize: '0.9rem', color: '#047857', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.5rem' }}>Our Motto</p>
                <h3 style={{ fontSize: '1.5rem', color: '#0366D6', margin: 0 }}>"{motto}"</h3>
              </div>

              <div style={{ textAlign: 'left' }}>
                <h4 style={{ color: '#0366D6', fontSize: '1.1rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
                  Our Mission
                </h4>
                <p style={{ color: '#475569', lineHeight: 1.7, marginBottom: '1.25rem', fontSize: '0.95rem' }}>
                  We are on a mission to make high-quality clinic management affordable, secure, and effortlessly smart for clinics worldwide. We believe that by automating appointments, digitizing records, and simplifying billing, we free up doctors and staff to focus on what truly matters: <strong>patient health.</strong>
                </p>
                <p style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                  We want information exchange between clinics, patients, and labs to be transparent, fast, and secure.
                </p>

                <h4 style={{ color: '#0366D6', fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  Our Background
                </h4>
                <p style={{ color: '#475569', lineHeight: 1.7, marginBottom: '1rem', fontSize: '0.95rem' }}>
                  We are a team of healthcare practitioners, tech innovators, and data security experts who were tired of seeing clinics drown in paperwork and manual follow-ups. We built ClinicPulse to be the only platform a modern clinic needs.
                </p>
                <div style={{ fontStyle: 'italic', color: '#64748b', fontSize: '0.9rem', borderLeft: '4px solid #10B981', paddingLeft: '1rem', marginTop: '1rem' }}>
                  "From a small clinic to a large multi-specialty hospital, ClinicPulse grows with you. We're not just software; we're your efficiency partner."
                </div>
              </div>
            </div>
          </div>
        )}

        {showPrivacyModal && (
          <div className="video-modal-overlay" onClick={() => setShowPrivacyModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '800px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2.5rem',
              textAlign: 'left',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowPrivacyModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '2.5rem', textAlign: 'center' }}>
                <img src="/heart_logo.jpg" alt="Logo" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '1rem' }} />
                <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Privacy <span className="gradient-text">Policy</span></h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Last Updated: April 10, 2026</p>
              </div>

              <div style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                <p style={{ marginBottom: '1.5rem' }}>
                  <strong>ClinicPulse Technologies</strong> ("ClinicPulse", "Company", "we", "us", or "our") owns and operates the website clinicpulse.org (the "Site"). ClinicPulse is committed to protecting your privacy and the security of your health and business information.
                </p>
                <p style={{ marginBottom: '1.5rem' }}>
                  This Privacy Policy explains how we collect, use, share, and protect the personal data of our users, including clinic administrators, doctors, staff, and patients.
                </p>
                <p style={{ marginBottom: '1.5rem', fontStyle: 'italic' }}>
                  Our privacy policy is subject to change at any time without notice. To make sure you are aware of any changes, please review this policy periodically.
                </p>

                <p style={{ fontWeight: 700, marginBottom: '1rem' }}>This Privacy Policy is published in compliance with:</p>
                <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                  <li>Section 43A of the IT Act, 2000</li>
                  <li>Regulation 4 of the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Information) Rules, 2011 (the "SPI Rules")</li>
                  <li>Regulation 3(1) of the Information Technology (Intermediaries Guidelines) Rules, 2011</li>
                </ul>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>1. Personal Information Collected</h3>
                <p style={{ marginBottom: '1rem' }}>ClinicPulse is the sole owner of the information collected on the Site. We will not sell, share, transfer, or rent your personal information to others in ways different from what is disclosed in this Privacy Policy and our Terms of Service.</p>
                <p style={{ marginBottom: '1rem' }}>We collect information when you:</p>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li>Register for a clinic account</li>
                  <li>Sign up for a free trial</li>
                  <li>Contact our support team</li>
                  <li>Use any of our features (patient management, scheduling, e-prescriptions, billing, telemedicine)</li>
                </ul>
                <p style={{ marginBottom: '1.5rem' }}>Personal information means any information that relates to a natural person, which, either directly or indirectly, is capable of identifying such person.</p>

                <p style={{ fontWeight: 700, marginBottom: '1rem' }}>Sensitive Personal Data (SPI) includes:</p>
                <ul style={{ marginBottom: '2rem', paddingLeft: '1.5rem' }}>
                  <li>Passwords</li>
                  <li>Financial information (bank accounts, credit/debit card details)</li>
                  <li>Physical, physiological, and mental health conditions</li>
                  <li>Medical records and history</li>
                  <li>Biometric information</li>
                  <li>Call data records</li>
                </ul>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>2. Note to All Users</h3>
                <div style={{ display: 'grid', gap: '1.5rem' }}>
                  <div>
                    <strong>Account Information:</strong> During registration, you are required to provide your clinic name, email address, phone number, and role.
                  </div>
                  <div>
                    <strong>Patient Data:</strong> You may upload patient health records, medical histories, etc. This data is stored securely and only accessible to authorized users.
                  </div>
                  <div>
                    <strong>IP Address & Cookies:</strong> We collect IP addresses to diagnose server problems and analyze trends.
                  </div>
                  <div>
                    <strong>Data Security:</strong> ClinicPulse takes complete precautions to keep your information secure. Access is limited to necessary personnel.
                  </div>
                  <div>
                    <strong>No Medical Liability:</strong> ClinicPulse provides tools only. We are not responsible for medical treatment or patient outcomes.
                  </div>
                </div>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>3. Note to Practitioners & Clinics</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Professional Information:</strong> You must provide accurate professional information. Providing false info is grounds for termination.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Patient Data Ownership:</strong> You retain full ownership of all patient medical records. We merely provide storage and management tools.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>4. Data Retention</h3>
                <p>Personal info is retained only as long as necessary. Once the purpose is achieved, data is deleted securely or anonymized for analytics.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>5. Data Deletion Request</h3>
                <p style={{ marginBottom: '1rem' }}>To submit a data deletion request: Email <strong>clinicpulsesupport@gmail.com</strong> with the subject "Data Deletion Request". We process requests within 30 days.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>6. Contact Us</h3>
                <p>Email: clinicpulsesupport@gmail.com<br />Phone: +91 9003665586<br />Live Chat: Available 24/7</p>
              </div>
            </div>
          </div>
        )}

        {showTermsModal && (
          <div className="video-modal-overlay" onClick={() => setShowTermsModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '800px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2.5rem',
              textAlign: 'left',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowTermsModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '2.5rem', textAlign: 'center' }}>
                <img src="/heart_logo.jpg" alt="Logo" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '1rem' }} />
                <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Terms & <span className="gradient-text">Conditions</span></h2>
                <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Last Updated: April 10, 2026</p>
              </div>

              <div style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                <p style={{ marginBottom: '1.5rem' }}>
                  <strong>ClinicPulse Technologies</strong> ("ClinicPulse", "Company", "we", "us", or "our") owns and operates the website clinicpulse.org and the ClinicPulse mobile application (together, the "Platform"). We provide clinic management software services to clinics, doctors, and healthcare professionals.
                </p>
                <p style={{ marginBottom: '1.5rem' }}>
                  These Terms & Conditions ("Agreement") govern your use of the Platform. By registering for or using ClinicPulse, you agree to be bound by this Agreement.
                </p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>1. About ClinicPulse</h3>
                <p style={{ marginBottom: '1rem' }}>ClinicPulse provides the following services:</p>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li><strong>Patient Management</strong> – Comprehensive digital health records with quick access to medical history, allergies, and lab results.</li>
                  <li><strong>Smart Scheduling</strong> – Reduce no-shows with automated appointment reminders and an intuitive drag-and-drop calendar.</li>
                  <li><strong>E-Prescriptions</strong> – Send prescriptions directly to pharmacies securely. Minimize errors and improve patient safety.</li>
                  <li><strong>Automated Billing</strong> – Easy invoicing and insurance claim processing. Get paid faster with integrated payment gateways.</li>
                  <li><strong>Advanced Analytics</strong> – Get detailed insights into clinic performance, patient trends, and financial growth with real-time dashboards.</li>
                  <li><strong>Telemedicine</strong> – Provide virtual consultations securely. Integrated high-quality video calling and session recording for remote care.</li>
                  <li><strong>Role-Based Access</strong> – Define roles for efficient task management (doctors, staff, admins).</li>
                </ul>
                <p style={{ marginBottom: '1.5rem' }}><strong>Support:</strong> Our tech support team is available 24/7 via live chat and email at clinicpulsesupport@gmail.com. Phone support is available at +91 9003665586.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>2. Definitions</h3>
                <p style={{ marginBottom: '1rem' }}><strong>"ClinicPulse"</strong> means the software created by ClinicPulse Technologies that is provided to users on a subscription basis.</p>
                <p style={{ marginBottom: '1rem' }}><strong>"Clinic" or "Doctor" or "You"</strong> means the healthcare provider, clinic, or professional registering for and using the Platform.</p>
                <p style={{ marginBottom: '1rem' }}><strong>"Patient" or "Customer"</strong> means the end patient whose data is stored and managed through the Platform.</p>
                <p style={{ marginBottom: '1rem' }}><strong>"Updates"</strong> means enhancements, bug fixes, and new versions made to ClinicPulse.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>"HIPAA Verified"</strong> means the Platform adheres to security and privacy standards consistent with HIPAA requirements.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>3. License Grant and Access to Software</h3>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Subscription License:</strong> Subject to all limitations herein, ClinicPulse grants you a SaaS (Software as a Service), limited, revocable, non-exclusive, and non-transferable right to access and use ClinicPulse as hosted by us.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Account Creation:</strong> You will be provided with login credentials to create a Clinic Account. You are responsible for maintaining the confidentiality of your login details.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Eligibility:</strong> Only persons who can form legally binding contracts under the Indian Contract Act, 1872 may use the Platform. If you are a minor (under 18 years), you may use the Platform only under the supervision of a parent or legal guardian. We reserve the right to terminate your membership if you are incompetent to contract.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Limitation on Use:</strong> ClinicPulse may be used by you for management of one clinic location per subscription unless you purchase a multi-location plan.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Customization:</strong> ClinicPulse has the sole right to modify features, add new functionality, or customize the Platform at its discretion.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Data Responsibility:</strong> You are solely responsible for the accuracy and completeness of all patient information you upload. You must maintain backup copies of your data. We will assist in restoring data from your last available backup in compatible format.</li>
                  <li style={{ marginBottom: '0.5rem' }}><strong>Prohibited Actions:</strong> You may not disassemble, decompile, reverse engineer, or copy ClinicPulse. You may not resell, sublicense, rent, or transfer your access to any third party.</li>
                  <li><strong>Authorized Users:</strong> Authorized users consist of your employees and contractors who do not compete with ClinicPulse. You are fully liable for their acts and omissions.</li>
                </ul>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>4. Technical Support</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Support Availability:</strong> We provide support 24/7 via live chat on our website and email at clinicpulsesupport@gmail.com. Phone support is available at +91 9003665586 (Monday–Saturday, 10 AM – 7 PM IST, excluding public holidays).</p>
                <p style={{ marginBottom: '1rem' }}><strong>Response Times:</strong> Response times vary based on issue severity. Critical issues affecting core functionality will be prioritized.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Electronic Communications:</strong> By using the Platform, you consent to receive communications from us via electronic records, including emails, notifications, and updates.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>5. Telemedicine Services</h3>
                <p style={{ marginBottom: '1rem' }}>Telemedicine consultations are between you and your patients. A consent form must be agreed to by patients before any telemedicine consultation.</p>
                <p style={{ marginBottom: '1rem' }}>ClinicPulse is not liable for any legal issues arising from telemedicine consultations or data shared between you and your patients.</p>
                <p style={{ marginBottom: '1rem' }}>We are not responsible for interruptions in communication due to technical or network failures.</p>
                <p style={{ marginBottom: '1.5rem' }}>All interactions during telemedicine consultations are strictly between you and your patient and are subject to doctor-patient confidentiality.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>6. Payments, Refund, and Cancellation</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Payments:</strong> Subscription fees for ClinicPulse must be paid in accordance with the plan you select. All applicable taxes are your responsibility.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Payment Collection:</strong> Any money collected from patients through our billing features is your liability. ClinicPulse only facilitates the payment process and is not liable for payment disputes, failures, or chargebacks.</p>
                <p style={{ marginBottom: '1rem' }}><strong>No Guarantee:</strong> ClinicPulse does not guarantee that using the Platform will generate any specific revenue or business for your clinic.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Refund Policy:</strong> Given the digital nature of our services, refunds are not granted unless required under applicable consumer protection laws. We will assess refund requests on their merits.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Cancellation:</strong> Cancellations can be requested by emailing clinicpulsesupport@gmail.com within 48 hours of purchase. Refunds, if approved, will be processed within 14 days using the same payment method used for purchase.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>7. Confidentiality</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Confidential Information:</strong> Both parties agree to retain in confidence all information disclosed that is designated as confidential. This Agreement's terms are considered Confidential Information.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Exclusions:</strong> Confidential Information does not include information that becomes publicly available through no fault of either party, or that was independently developed.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Protection:</strong> Each party will protect the other's Confidential Information using reasonable precautions. Confidentiality obligations survive termination of this Agreement for three (3) years. Trade secrets remain protected indefinitely.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Your Data:</strong> Any data you provide to ClinicPulse will be protected and accessed only with your permission, governed by our Privacy Policy.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>8. Representations and Warranties</h3>
                <p style={{ marginBottom: '0.5rem', fontWeight: 700 }}>By You (Clinic/Doctor): You represent and warrant that:</p>
                <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                  <li>You are 18 years or older and have the authority to enter into this Agreement.</li>
                  <li>You will not transfer your account or login credentials to any third party.</li>
                  <li>All information you upload is true, accurate, and complete.</li>
                  <li>You have necessary rights from patients to upload their health records.</li>
                  <li>You will not use ClinicPulse for any unlawful purpose.</li>
                  <li>You will not interfere with or disrupt the Platform or its servers.</li>
                  <li>You will comply with all applicable laws.</li>
                </ul>
                <p style={{ marginBottom: '1rem' }}><strong>By ClinicPulse:</strong> The Platform is provided "as is" and "as available". We make no express or implied warranties about merchantability, fitness for a particular purpose, or non-infringement.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Disclaimer of Warranties:</strong><br />USE OF THE PLATFORM IS AT YOUR OWN RISK. CLINICPULSE MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND. WE DISCLAIM ALL WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE PLATFORM WILL OPERATE WITHOUT INTERRUPTION OR ERROR.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Limitation of Liability:</strong><br />TO THE MAXIMUM EXTENT PERMITTED BY LAW, CLINICPULSE SHALL NOT BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, PUNITIVE, OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OR INABILITY TO USE THE PLATFORM, INCLUDING LOSS OF PROFITS, DATA, OR BUSINESS INTERRUPTION.</p>
                <p style={{ marginBottom: '1rem' }}><strong>No Medical Liability:</strong> ClinicPulse provides management software only. We are not responsible for the quality of medical treatment, diagnoses, prescriptions, or patient outcomes. You remain solely responsible for all medical decisions.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Third Parties:</strong> We are not responsible for unauthorized access to your data, third-party services, or any threatening, defamatory, or illegal conduct of others.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Force Majeure:</strong> We shall not be liable for any downtime or delay caused by circumstances beyond our reasonable control, including cyber-attacks, acts of God, pandemics, floods, earthquakes, strikes, or internet service provider failures.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>9. Term and Termination</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Term:</strong> This Agreement remains in effect for one (1) year and automatically renews for successive one-year periods unless either party gives 60 days' notice before the renewal date.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Termination for Cause:</strong> Either party may terminate if the other party breaches a material obligation and fails to cure within 30 days of notice.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Termination by ClinicPulse for Convenience:</strong> We may terminate this Agreement by providing 90 days' written notice if we determine it is no longer feasible to support the Platform.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Effect of Termination:</strong> Upon termination, we will provide you with a complete export of your database in electronic format within a reasonable time, and your account will be deactivated.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>10. Sharing of Information with Affiliates</h3>
                <p style={{ marginBottom: '1.5rem' }}>We may share your information with our affiliates if required to provide the services you requested. This includes patient health records and other data.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>11. General Provisions</h3>
                <p style={{ marginBottom: '1rem' }}><strong>Assignment:</strong> You may not assign this Agreement without our prior written consent.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Waiver:</strong> Failure to enforce any right does not constitute a waiver.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Notices:</strong> All notices shall be in writing and sent to the email address or physical address provided.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Independent Parties:</strong> Neither party is an agent or employee of the other. No party has authority to bind the other.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Loss of Data:</strong> We are not responsible for data lost due to your negligence.</p>
                <p style={{ marginBottom: '1rem' }}><strong>Governing Law & Arbitration:</strong> This Agreement shall be governed by the laws of India. Any disputes shall be settled by arbitration in accordance with the Arbitration and Conciliation Act, 1996. The place of arbitration shall be [Your City, e.g., Chennai or Mumbai]. The language of arbitration shall be English.</p>
                <p style={{ marginBottom: '1.5rem' }}><strong>Entire Agreement:</strong> This Agreement constitutes the entire agreement between the parties and supersedes all prior communications.</p>

                <h3 style={{ color: '#0366D6', marginTop: '2.5rem', marginBottom: '1rem', fontSize: '1.25rem' }}>12. Contact Us</h3>
                <p>Email: clinicpulsesupport@gmail.com<br />Phone: +91 9003665586<br />Live Chat: Available 24/7 on our website</p>
              </div>
            </div>
          </div>
        )}

        {showSupportModal && (
          <div className="video-modal-overlay" onClick={() => setShowSupportModal(false)} style={{ zIndex: 10000 }}>
            <div className="about-modal-container glass animate-scale-up custom-scrollbar" onClick={(e) => e.stopPropagation()} style={{
              maxWidth: '600px',
              width: '95%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: '3rem 2.5rem',
              textAlign: 'left',
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '24px',
              border: '1px solid #e0f2fe',
              boxShadow: '0 30px 60px rgba(3, 102, 214, 0.2)',
              position: 'relative'
            }}>
              <button
                className="modal-close-btn"
                onClick={() => setShowSupportModal(false)}
                style={{ color: '#64748b', position: 'sticky', top: '0', float: 'right', marginTop: '-1.5rem', marginRight: '-1rem' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                  <div style={{ width: '60px', height: '60px', background: '#E8F9F1', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10B981' }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  </div>
                </div>
                <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                  <img src="/heart_logo.jpg" alt="Logo" style={{ width: '40px', height: '40px', borderRadius: '8px' }} />
                  ClinicPulse <span className="gradient-text">Support</span>
                </h2>
                <p style={{ color: '#64748b', fontSize: '0.95rem' }}>We're here to help you succeed.</p>
              </div>

              <div style={{ color: '#475569', lineHeight: 1.7, fontSize: '0.95rem' }}>
                <h3 style={{ color: '#0366D6', marginBottom: '1.25rem', fontSize: '1.1rem', borderBottom: '1px solid #e2e8f0', paddingBottom: '0.5rem' }}>Technical Support Availability:</h3>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <div style={{ marginTop: '2px', color: '#3B82F6' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                    </div>
                    <div>
                      <strong style={{ display: 'block', color: '#1e293b' }}>Live Chat:</strong>
                      <span>24/7 on our website</span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <div style={{ marginTop: '2px', color: '#3B82F6' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    </div>
                    <div>
                      <strong style={{ display: 'block', color: '#1e293b' }}>Email Support:</strong>
                      <span>clinicpulsesupport@gmail.com </span>
                      <span style={{ fontSize: '0.85rem', color: '#10B981', display: 'block', marginTop: '2px' }}>(Response within 24 hours)</span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <div style={{ marginTop: '2px', color: '#3B82F6' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    </div>
                    <div>
                      <strong style={{ display: 'block', color: '#1e293b' }}>Phone Support:</strong>
                      <span>+91 9003665586</span>
                      <span style={{ fontSize: '0.85rem', color: '#64748b', display: 'block', marginTop: '2px' }}>(Monday–Saturday, 10:00 AM – 7:00 PM IST)</span>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: '2rem', padding: '1.25rem', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                  <div style={{ marginBottom: '1rem' }}>
                    <strong style={{ color: '#0f172a' }}>📅 Support Holidays:</strong>
                    <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>Phone support not available on public holidays. Email and chat remain available.</p>
                  </div>
                  <div>
                    <strong style={{ color: '#0f172a' }}>🎫 Ticket System:</strong>
                    <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem' }}>For critical issues, you can raise a support ticket via email. We will respond based on the severity of the issue.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Visit Time Picker Modal */}
      {showTimePicker && (
        <div className="visit-time-modal-overlay">
          <div className="visit-time-modal-content">
            <div className="modal-header">
              <h3>🕒 Select <span className="gradient-text">Visit Timings</span></h3>
              <button className="close-btn" onClick={() => setShowTimePicker(false)}>×</button>
            </div>

            <div className="time-picker-body">
              <div className="days-sidebar">
                {Object.keys(visitTimes).map(day => (
                  <button
                    key={day}
                    className={`day-btn ${activeDay === day ? 'active' : ''}`}
                    onClick={() => setActiveDay(day)}
                  >
                    {day}
                    {visitTimes[day].length > 0 && <span className="day-dot"></span>}
                  </button>
                ))}
              </div>

              <div className="timings-panel">
                <h4>Available times for {activeDay}</h4>


                {/* Session Selector */}
                <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem', background: '#f1f5f9', padding: '0.35rem', borderRadius: '12px' }}>
                  {['Morning', 'Afternoon', 'Evening'].map(slot => (
                    <button
                      key={slot}
                      onClick={() => {
                        setActiveSlot(slot);
                        if (slot === 'Morning') { setCustomHour('09'); setCustomPeriod('AM'); }
                        else if (slot === 'Afternoon') { setCustomHour('02'); setCustomPeriod('PM'); }
                        else if (slot === 'Evening') { setCustomHour('07'); setCustomPeriod('PM'); }
                      }}
                      style={{
                        flex: 1,
                        padding: '0.6rem',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '0.85rem',
                        fontWeight: 700,
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        background: activeSlot === slot ? 'white' : 'transparent',
                        color: activeSlot === slot ? 'var(--primary)' : '#64748b',
                        boxShadow: activeSlot === slot ? '0 4px 12px rgba(0,0,0,0.05)' : 'none'
                      }}
                    >
                      {slot === 'Morning' ? '🌅' : slot === 'Afternoon' ? '☀️' : '🌙'} {slot}
                    </button>
                  ))}
                </div>

                <div className="slots-grid">
                  <h5 style={{ gridColumn: '1 / -1', margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#1e293b' }}>
                    Available {activeSlot} Timings:
                  </h5>
                  {timeOptions.map(time => {
                    const isSelected = visitTimes[activeDay].includes(time);
                    return (
                      <button
                        key={time}
                        className={`time-slot ${isSelected ? 'selected' : ''}`}
                        onClick={() => handleAddTime(activeDay, time)}
                      >
                        {time}
                      </button>
                    );
                  })}
                </div>

                {/* Custom Time Picker */}
                <div style={{ background: '#f0f9ff', padding: '1rem', borderRadius: '12px', border: '1px solid #e0f2fe', marginTop: '1.25rem' }}>
                  <p style={{ margin: '0 0 0.75rem 0', fontSize: '0.85rem', fontWeight: 700, color: '#0369a1' }}>Add custom {activeSlot} time:</p>
                  <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                    <select
                      value={customHour}
                      onChange={(e) => setCustomHour(e.target.value)}
                      style={{ flex: 1, padding: '0.6rem 0.5rem', borderRadius: '8px', border: '1px solid #bae6fd', fontSize: '0.9rem', background: 'white' }}
                    >
                      {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map(h => <option key={h} value={h}>{h}</option>)}
                    </select>
                    <span style={{ alignSelf: 'center', fontWeight: 700, color: '#0369a1' }}>:</span>
                    <select
                      value={customMinute}
                      onChange={(e) => setCustomMinute(e.target.value)}
                      style={{ flex: 1, padding: '0.6rem 0.5rem', borderRadius: '8px', border: '1px solid #bae6fd', fontSize: '0.9rem', background: 'white' }}
                    >
                      {['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'].map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                    <select
                      value={customPeriod}
                      onChange={(e) => setCustomPeriod(e.target.value)}
                      style={{ flex: 1, padding: '0.6rem 0.5rem', borderRadius: '8px', border: '1px solid #bae6fd', fontSize: '0.9rem', background: 'white' }}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                    <button
                      className="btn btn-secondary"
                      style={{ padding: '0.6rem 1rem', fontSize: '0.85rem', fontWeight: 700 }}
                      onClick={() => {
                        const finalTime = `${customHour}:${customMinute} ${customPeriod}`;
                        handleAddTime(activeDay, finalTime);
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>

                <div className="selected-times-display" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '1rem', marginBottom: '1rem', marginTop: '1.25rem' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                    <h5 style={{ margin: 0 }}>Current Day: {activeDay}</h5>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      {visitTimes[activeDay].length > 0 && (
                        <>
                          <button
                            onClick={applyToAllDays}
                            title="Apply this timing to every day of the week"
                            style={{ background: '#f0f9ff', color: '#0369a1', border: '1px solid #bae6fd', borderRadius: '6px', padding: '0.3rem 0.6rem', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer' }}
                          >
                            Apply to all
                          </button>
                          <button
                            onClick={() => clearDayTimings(activeDay)}
                            title="Remove all timings for this day"
                            style={{ background: '#fef2f2', color: '#ef4444', border: '1px solid #fee2e2', borderRadius: '6px', padding: '0.3rem 0.6rem', fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer' }}
                          >
                            Clear Day
                          </button>
                        </>
                      )}
                    </div>
                  </div>


                  {visitTimes[activeDay].length === 0 ? (
                    <div style={{ fontSize: '0.8rem', color: '#94a3b8', fontStyle: 'italic', paddingLeft: '1rem' }}>No timings set for {activeDay}</div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                      {(() => {
                        const sorted = [...visitTimes[activeDay]].sort((a, b) => {
                          const timeToVal = (s) => {
                            const [t, p] = s.split(' ');
                            let [h, m] = t.split(':').map(Number);
                            if (p === 'PM' && h !== 12) h += 12;
                            if (p === 'AM' && h === 12) h = 0;
                            return h * 60 + m;
                          };
                          return timeToVal(a) - timeToVal(b);
                        });


                        let pairs = [];
                        for (let i = 0; i < sorted.length; i += 2) {
                          pairs.push({ start: sorted[i], end: sorted[i + 1] });
                        }

                        return pairs.map((pair, pIdx) => (
                          <div key={pIdx} className="time-tag" style={{ justifyContent: 'space-between', padding: '0.5rem 0.75rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                              <span style={{ fontWeight: 700, color: '#0369a1', fontSize: '0.75rem' }}>
                                {getSessionFromTime(pair.start)}:
                              </span>
                              <span style={{ fontSize: '0.75rem', opacity: 0.8 }}>From</span>
                              <span>{pair.start}</span>
                              {pair.end && (
                                <>
                                  <span style={{ fontSize: '0.75rem', opacity: 0.8 }}>To</span>
                                  {getSessionFromTime(pair.start) !== getSessionFromTime(pair.end) && (
                                    <span style={{ fontWeight: 700, color: '#0369a1', fontSize: '0.75rem' }}>
                                      {getSessionFromTime(pair.end)}:
                                    </span>
                                  )}
                                  <span>{pair.end}</span>
                                </>
                              )}
                            </div>
                            <div style={{ display: 'flex', gap: '4px' }}>
                              {/* Allow removing individual times by finding original index */}
                              <button onClick={() => removeTime(activeDay, visitTimes[activeDay].indexOf(pair.start))}>×</button>
                              {pair.end && <button onClick={() => removeTime(activeDay, visitTimes[activeDay].indexOf(pair.end))}>×</button>}
                            </div>
                          </div>
                        ));
                      })()}
                    </div>
                  )}
                </div>

                <div className="global-summary" style={{ background: '#f8fafc', padding: '1rem', borderRadius: '12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                    <h5 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#10b981' }}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                      Full Weekly Schedule:
                    </h5>
                    {getGroupedSummary(visitTimes).length > 0 && (
                      <button
                        onClick={clearAllVisitTimes}
                        style={{ background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', padding: '0.25rem 0.6rem', fontSize: '0.7rem', fontWeight: 700, cursor: 'pointer' }}
                      >
                        Clear All
                      </button>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                    {getGroupedSummary(visitTimes).length === 0 ? (
                      <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.8rem', fontStyle: 'italic' }}>No timings selected yet.</p>
                    ) : (
                      getGroupedSummary(visitTimes).map((group, idx) => (
                        <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '0.8rem', background: 'white', padding: '0.5rem 0.75rem', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                          <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <span style={{ fontWeight: 700, color: '#1e293b', minWidth: '100px' }}>
                              {group.start === group.end ? group.start : `${group.start}-${group.end}`}:
                            </span>
                            <span style={{ color: '#64748b' }}>{group.sessionStr}</span>
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              removeGroupTimings(group.start, group.end);
                            }}
                            style={{ border: 'none', background: '#fef2f2', color: '#ef4444', width: '20px', height: '20px', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '0.9rem' }}
                          >
                            ×
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={() => setShowTimePicker(false)}>
                Confirm Timings
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function FeatureCard({ icon, image, title, desc, index = 0 }) {
  const [imgSrc, setImgSrc] = useState(image);

  useEffect(() => {
    setImgSrc(image);
  }, [image]);

  const gradients = [
    'linear-gradient(135deg, #0EA5E9 0%, #2563EB 100%)',
    'linear-gradient(135deg, #F43F5E 0%, #E11D48 100%)',
    'linear-gradient(135deg, #10B981 0%, #059669 100%)',
    'linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)',
    'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
    'linear-gradient(135deg, #14B8A6 0%, #0D9488 100%)'
  ];

  const bgGradient = gradients[index % gradients.length];

  return (
    <div className="feature-card-blog">
      {imgSrc ? (
        <div className="feature-card-image">
          <img
            src={imgSrc}
            alt={title}
            onError={(e) => {
              e.target.onerror = null;
              setImgSrc(null);
            }}
          />
        </div>
      ) : (
        <div className="feature-card-image" style={{ background: bgGradient }}>
          {icon}
        </div>
      )}
      <h3 className="feature-card-title">{title}</h3>
      <p className="feature-card-desc">{desc}</p>

      <div className="feature-card-footer">
        <a href="#read-more" className="read-more-link" onClick={(e) => e.preventDefault()}>
          Read More
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '6px' }}>
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </div>
    </div>
  );
}

function StepCard({ step, title, desc, footer, footerIcon, footerColor }) {
  return (
    <div className="step-card">
      <div className="step-header">
        <div className="step-label">Step <span>{step}</span>: {title}</div>
      </div>
      <p className="step-desc">{desc}</p>
      <div className="step-footer" style={{ color: footerColor }}>
        {footerIcon}
        <span>{footer}</span>
      </div>
    </div>
  );
}

function InfoItem({ icon, label, text }) {
  return (
    <div className="info-item">
      <div className="info-icon">{icon}</div>
      <div>
        <div style={{ fontWeight: 700, fontSize: '0.875rem' }}>{label}</div>
        <div style={{ color: 'var(--text-muted)' }}>{text}</div>
      </div>
    </div>
  );
}

export default App;
